export {
  stationWarns,
  queryFaultListOrd,
  getNextstepData,
  searchFaultStateByFaul,
  updateFaultState,
  videoLIst,
};

// 前池水位
export const getBeforeWaterFlow = {
  status: 0,
  code: 200,
  success: true,
  data: {
    ecologicalFlow: 0,
    foreLevel: 0,
  },
  msg: '操作成功',
};

// 首页机组信息
export const getPowerDetail = {
  status: 0,
  code: 200,
  success: true,
  data: {
    detpId: 2000000134081,
    detpName: '高板岩二站',
    installedCapacity: 500.0,
    power: 0.0,
    electricDay: 0.0,
    electricMon: 0.20000000298023224,
    planMon: 0.0,
    electricYear: 180348.19995117188,
    planYear: 1051000.0,
    generationDays: [
      {
        date: '2023-11-01',
        generate: 0.2,
        load: 0.0,
      },
      {
        date: '2023-11-02',
        generate: 0.0,
        load: 0.0,
      },
    ],
    generationMons: [
      {
        year: 2023,
        month: 1,
        strMonth: '2023-01-01',
        power: 41300.0,
        planPower: 157000.0,
      },
      {
        year: 2023,
        month: 2,
        strMonth: '2023-02-01',
        power: 0.0,
        planPower: 134000.0,
      },
      {
        year: 2023,
        month: 3,
        strMonth: '2023-03-01',
        power: 31000.0,
        planPower: 120000.0,
      },
      {
        year: 2023,
        month: 4,
        strMonth: '2023-04-01',
        power: 66200.0,
        planPower: 115000.0,
      },
      {
        year: 2023,
        month: 5,
        strMonth: '2023-05-01',
        power: 39800.0,
        planPower: 143000.0,
      },
      {
        year: 2023,
        month: 6,
        strMonth: '2023-06-01',
        power: 0.0,
        planPower: 125000.0,
      },
      {
        year: 2023,
        month: 7,
        strMonth: '2023-07-01',
        power: 0.0,
        planPower: 120000.0,
      },
      {
        year: 2023,
        month: 8,
        strMonth: '2023-08-01',
        power: 0.0,
        planPower: 67000.0,
      },
      {
        year: 2023,
        month: 9,
        strMonth: '2023-09-01',
        power: 0.0,
        planPower: 0.0,
      },
      {
        year: 2023,
        month: 10,
        strMonth: '2023-10-01',
        power: 2048.0,
        planPower: 70000.0,
      },
      {
        year: 2023,
        month: 11,
        strMonth: '2023-11-01',
        power: 0.2,
        planPower: 0.0,
      },
      {
        year: 2023,
        month: 12,
        strMonth: '2023-12-01',
        power: 0.0,
        planPower: 0.0,
      },
    ],
  },
  msg: '操作成功',
};

// 当前天气
export const getNowWeatherInfo = {
  status: 0,
  code: 200,
  success: true,
  data: {
    code: 'UNKNOWN',
    updateTime: '2023-11-02T10:22:00+08:00',
    fxLink: 'https://www.qweather.com/weather/huoshan-101221506.html',
    refer: {
      sources: ['QWeather'],
      license: ['CC BY-SA 4.0'],
    },
    expand: null,
    now: {
      obsTime: '2023-11-02T10:14:00+08:00',
      temp: '25',
      feelsLike: '22',
      icon: '100',
      text: '晴',
      wind360: '2',
      windDir: '北风',
      windScale: '1',
      windSpeed: '5',
      humidity: '48',
      precip: '0.0',
      pressure: '1005',
      vis: '17',
      cloud: '0',
      dew: '13',
    },
  },
  msg: '操作成功',
};

// 七天天气
export const get7dWeatherInfo = {
  status: 0,
  code: 200,
  success: true,
  data: {
    code: 'UNKNOWN',
    updateTime: '2023-11-01T08:35:00+08:00',
    fxLink: 'https://www.qweather.com/weather/huoshan-101221506.html',
    refer: {
      sources: ['QWeather'],
      license: ['CC BY-SA 4.0'],
    },
    expand: null,
    daily: [
      {
        fxDate: '2023-11-01',
        sunrise: '06:29',
        sunset: '17:29',
        moonrise: '19:55',
        moonset: '10:03',
        moonPhase: '亏凸月',
        moonPhaseIcon: '805',
        tempMax: '31',
        tempMin: '12',
        iconDay: '100',
        textDay: '晴',
        iconNight: '150',
        textNight: '晴',
        wind360Day: '180',
        windDirDay: '南风',
        windScaleDay: '1-3',
        windSpeedDay: '16',
        wind360Night: '225',
        windScaleNight: '1-3',
        windSpeedNight: '16',
        humidity: '69',
        precip: '0.0',
        pressure: '985',
        vis: '25',
        cloud: '0',
        uvIndex: '4',
        windDirNight: '西南风',
      },
      {
        fxDate: '2023-11-02',
        sunrise: '06:30',
        sunset: '17:28',
        moonrise: '20:49',
        moonset: '11:02',
        moonPhase: '亏凸月',
        moonPhaseIcon: '805',
        tempMax: '30',
        tempMin: '14',
        iconDay: '100',
        textDay: '晴',
        iconNight: '151',
        textNight: '多云',
        wind360Day: '216',
        windDirDay: '西南风',
        windScaleDay: '1-3',
        windSpeedDay: '16',
        wind360Night: '212',
        windScaleNight: '1-3',
        windSpeedNight: '16',
        humidity: '65',
        precip: '0.0',
        pressure: '983',
        vis: '25',
        cloud: '0',
        uvIndex: '1',
        windDirNight: '西南风',
      },
      {
        fxDate: '2023-11-03',
        sunrise: '06:31',
        sunset: '17:27',
        moonrise: '21:46',
        moonset: '11:54',
        moonPhase: '亏凸月',
        moonPhaseIcon: '805',
        tempMax: '29',
        tempMin: '14',
        iconDay: '305',
        textDay: '小雨',
        iconNight: '305',
        textNight: '小雨',
        wind360Day: '90',
        windDirDay: '东风',
        windScaleDay: '3-4',
        windSpeedDay: '25',
        wind360Night: '311',
        windScaleNight: '1-3',
        windSpeedNight: '16',
        humidity: '82',
        precip: '2.4',
        pressure: '988',
        vis: '23',
        cloud: '60',
        uvIndex: '2',
        windDirNight: '西北风',
      },
      {
        fxDate: '2023-11-04',
        sunrise: '06:31',
        sunset: '17:27',
        moonrise: '22:45',
        moonset: '12:39',
        moonPhase: '亏凸月',
        moonPhaseIcon: '805',
        tempMax: '22',
        tempMin: '18',
        iconDay: '305',
        textDay: '小雨',
        iconNight: '305',
        textNight: '小雨',
        wind360Day: '22',
        windDirDay: '北风',
        windScaleDay: '1-3',
        windSpeedDay: '16',
        wind360Night: '259',
        windScaleNight: '1-3',
        windSpeedNight: '16',
        humidity: '97',
        precip: '7.3',
        pressure: '985',
        vis: '15',
        cloud: '100',
        uvIndex: '1',
        windDirNight: '西风',
      },
      {
        fxDate: '2023-11-05',
        sunrise: '06:32',
        sunset: '17:26',
        moonrise: '23:42',
        moonset: '13:17',
        moonPhase: '下弦月',
        moonPhaseIcon: '806',
        tempMax: '18',
        tempMin: '9',
        iconDay: '305',
        textDay: '小雨',
        iconNight: '150',
        textNight: '晴',
        wind360Day: '312',
        windDirDay: '西北风',
        windScaleDay: '3-4',
        windSpeedDay: '25',
        wind360Night: '295',
        windScaleNight: '1-3',
        windSpeedNight: '16',
        humidity: '76',
        precip: '7.0',
        pressure: '992',
        vis: '24',
        cloud: '50',
        uvIndex: '1',
        windDirNight: '西北风',
      },
      {
        fxDate: '2023-11-06',
        sunrise: '06:33',
        sunset: '17:25',
        moonrise: '',
        moonset: '13:50',
        moonPhase: '残月',
        moonPhaseIcon: '807',
        tempMax: '16',
        tempMin: '7',
        iconDay: '100',
        textDay: '晴',
        iconNight: '150',
        textNight: '晴',
        wind360Day: '-1',
        windDirDay: '无持续风向',
        windScaleDay: '1-3',
        windSpeedDay: '16',
        wind360Night: '180',
        windScaleNight: '1-3',
        windSpeedNight: '16',
        humidity: '64',
        precip: '0.0',
        pressure: '990',
        vis: '25',
        cloud: '0',
        uvIndex: '4',
        windDirNight: '南风',
      },
      {
        fxDate: '2023-11-07',
        sunrise: '06:34',
        sunset: '17:24',
        moonrise: '00:39',
        moonset: '14:18',
        moonPhase: '残月',
        moonPhaseIcon: '807',
        tempMax: '19',
        tempMin: '9',
        iconDay: '101',
        textDay: '多云',
        iconNight: '151',
        textNight: '多云',
        wind360Day: '110',
        windDirDay: '东风',
        windScaleDay: '1-3',
        windSpeedDay: '16',
        wind360Night: '225',
        windScaleNight: '1-3',
        windSpeedNight: '16',
        humidity: '57',
        precip: '0.0',
        pressure: '985',
        vis: '25',
        cloud: '0',
        uvIndex: '4',
        windDirNight: '西南风',
      },
    ],
  },
  msg: '操作成功',
};

// 水库水位雨量
export const getRealData = {
  status: 0,
  code: 200,
  success: true,
  data: [
    {
      fieldName: '库水位',
      signage: 'rz',
      value: '529.06',
      q: 0,
      time: '2023-11-02 10:00:00.000',
    },
    {
      fieldName: '库雨量',
      signage: 'drp',
      value: '0.0',
      q: 0,
      time: '2023-11-02 10:00:00.000',
    },
    {
      fieldName: '水势',
      signage: 'wptn',
      value: '6',
      q: 0,
      time: '2023-11-02 10:00:00.000',
    },
  ],
  msg: '操作成功',
};

// 实时故障
const stationWarns = {
  status: 0,
  code: 200,
  success: true,
  data: [
    {
      ord: '1#机组前导',
      faultId: '17230100205|1#机组前导|ebd132e4b2c643af9397bf18a1da5cba',
      status: 1,
      station: '17230100205',
      stationName: '高板岩二站',
      ftype: '智能预警',
      finfo: '1#机组前导轴承温度整体升高',
      createTime: '2023-11-01 06:20:00',
      info: '{"info": "1#机组前导轴瓦温度为：61.8、63.7，设定的告警温度为：60.0","chart_type": "histogram", "chart_data": {"title": "","x": ["轴瓦1", "轴瓦2"],"y": [61.8, 63.7], "top": "60"}}',
      name: '轴承温度整体升高',
      deviceId: '17230100205|1#机组前导|a30e3971720b4116b94dd941cdab2fdf',
      modelDeviceCode: null,
    },
  ],
  msg: '操作成功',
};

//   故障搜索 故障列表

const queryFaultListOrd = {
  records: [
    {
      createDept: '2000000134079',
      createTime: '2023-10-11 10:57:12',
      updateTime: '2023-10-12 00:00:25',
      status: '-1',
      isDeleted: 0,
      id: '1711938974530002945',
      tenantId: '200000',
      fdpId: '17230100206|1#机组|7b5a217f0ec843e6b50eae792bc384d8',
      fdpPartition: null,
      name: '转轮与导叶相互干扰',
      info: '水轮机动静干涉，由于导叶与水流的相互作用以及边界层的影响，导叶出口处的速度是不均匀的。又由于导叶的出口速度分布就是转轮叶片的进口条件，所以，每一个转轮叶片在转动一个导叶间距的过程中，其进口边界条件发生周期性的变化。作用于这个叶片上的力（包括径向、切向和轴向力）也会发生一个周期性的变化',
      emCode: null,
      detectability: '3.0',
      severity: '2',
      fdpDeviceId: '17230100206|1#机组|741442f515564cc5921e0ee84fd4ea7e',
      instanceDeviceCode: null,
      fdpDeviceName: '机组',
      ord: '1#机组',
      display: 1,
      stationId: '17230100206',
      field: '主机及辅助设备',
      createUserName: null,
      updateUserName: null,
      faultAmount: 2,
      modelDeviceCode: 'SLJ001',
    },
    {
      createDept: '2000000134079',
      createTime: '2023-10-11 10:57:12',
      updateTime: '2023-10-12 00:00:25',
      status: 3,
      isDeleted: 0,
      id: '1711938974538391555',
      tenantId: '200000',
      fdpId: '17230100206|1#机组|2e104850934b4611986a4fc7738a8549',
      fdpPartition: null,
      name: '防跳线圈极性反了',
      info: '生产把防跳线圈的 U 或 I 线圈极性焊接反；',
      emCode: null,
      detectability: '1.0',
      severity: '1',
      fdpDeviceId: '17230100206|1#机组|c822f993681742e3b0df81ae909f0bdf',
      instanceDeviceCode: null,
      fdpDeviceName: '保护器（AC板）',
      ord: '1#机组',
      display: 1,
      stationId: '17230100206',
      field: '保护',
      createUserName: null,
      updateUserName: null,
      faultAmount: 2,
      modelDeviceCode: 'SLJ002',
    },
    {
      createDept: '2000000134079',
      createTime: '2023-10-11 10:57:12',
      updateTime: '2023-10-12 00:00:25',
      status: 3,
      isDeleted: 0,
      id: '1711938974555168770',
      tenantId: '200000',
      fdpId: '17230100206|1#机组|89abdb9a8e7e46f38ec15d626c08f659',
      fdpPartition: null,
      name: '控制回路电源保险熔断',
      info: '',
      emCode: null,
      detectability: '1.0',
      severity: '1',
      fdpDeviceId: '17230100206|1#机组|c822f993681742e3b0df81ae909f0bdf',
      instanceDeviceCode: null,
      fdpDeviceName: '保护器（AC板）',
      ord: '1#机组',
      display: 1,
      stationId: '17230100206',
      field: '保护',
      createUserName: null,
      updateUserName: null,
      faultAmount: 2,
      modelDeviceCode: null,
    },
    {
      createDept: '2000000134079',
      createTime: '2023-10-11 10:57:12',
      updateTime: '2023-10-12 00:00:26',
      status: -1,
      isDeleted: 0,
      id: '1711938974701969410',
      tenantId: '200000',
      fdpId: '17230100206|1#机组|d9545fd09cb0442d9258579bbe04fb42',
      fdpPartition: null,
      name: '机组转速开机后表现异常',
      info: '',
      emCode: null,
      detectability: '1.0',
      severity: '1',
      fdpDeviceId: '17230100206|1#机组|33109f860a6f48859241fbed3c861760',
      instanceDeviceCode: null,
      fdpDeviceName: '水轮机',
      ord: '1#机组',
      display: 1,
      stationId: '17230100206',
      field: '主机及辅助设备',
      createUserName: null,
      updateUserName: null,
      faultAmount: 2,
      modelDeviceCode: 'SLJ003',
    },
    {
      createDept: '2000000134077',
      createTime: '2023-10-11 10:57:10',
      updateTime: '2023-10-12 00:00:10',
      status: -1,
      isDeleted: 0,
      id: '1711938965575163906',
      tenantId: '200000',
      fdpId: '17230100202|1#机组|37d7bff828df4a74b578286ebb519727',
      fdpPartition: null,
      name: '位移传感器坏',
      info: '报反馈断线或开度跳动',
      emCode: null,
      detectability: '1.0',
      severity: '1',
      fdpDeviceId: '17230100202|1#机组|df173f0617a84d918b4833500ac0c7c5',
      instanceDeviceCode: null,
      fdpDeviceName: '电气控制部分',
      ord: '1#机组',
      display: 1,
      stationId: '17230100202',
      field: '调速器',
      createUserName: null,
      updateUserName: null,
      faultAmount: 1,
      modelDeviceCode: 'SLJ004',
    },
    {
      createDept: '2000000134077',
      createTime: '2023-10-11 10:57:10',
      updateTime: '2023-10-12 00:00:10',
      status: 2,
      isDeleted: 0,
      id: '1711938965625495554',
      tenantId: '200000',
      fdpId: '17230100202|1#机组|6d61d5c5151544c092723759b355f015',
      fdpPartition: null,
      name: '调理板坏',
      info: '<p>调理板可以调整获取到的开度信号，使其更加准确。</p>',
      emCode: null,
      detectability: '1.0',
      severity: '1',
      fdpDeviceId: '17230100202|1#机组|df173f0617a84d918b4833500ac0c7c5',
      instanceDeviceCode: null,
      fdpDeviceName: '电气控制部分',
      ord: '1#机组',
      display: 1,
      stationId: '17230100202',
      field: '调速器',
      createUserName: null,
      updateUserName: null,
      faultAmount: 1,
      modelDeviceCode: 'SLJ005',
    },
    {
      createDept: '2000000134079',
      createTime: '2023-10-11 10:57:12',
      updateTime: '2023-10-12 00:00:25',
      status: 3,
      isDeleted: 0,
      id: '1711938974542585857',
      tenantId: '200000',
      fdpId: '17230100206|1#机组|42f9eeaafe0c425bbe655f557f944f4e',
      fdpPartition: null,
      name: '遥信公共端未接/接错',
      info: '<p>外部遥信信号，一端需要接入公共端，另一端接入遥信输入端。</p>',
      emCode: null,
      detectability: '1.0',
      severity: '1',
      fdpDeviceId: '17230100206|1#机组|c822f993681742e3b0df81ae909f0bdf',
      instanceDeviceCode: null,
      fdpDeviceName: '保护器（AC板）',
      ord: '1#机组',
      display: 1,
      stationId: '17230100206',
      field: '保护',
      createUserName: null,
      updateUserName: null,
      faultAmount: 1,
      modelDeviceCode: 'SLJ006',
    },
    {
      createDept: '2000000134079',
      createTime: '2023-10-11 10:57:12',
      updateTime: '2023-10-12 00:00:26',
      status: 3,
      isDeleted: 0,
      id: '1711938974660026370',
      tenantId: '200000',
      fdpId: '17230100206|1#机组|35476ad8a1174c029e260ea5360aa60e',
      fdpPartition: null,
      name: '遥信采样信号异常',
      info: '<p>采样信号与实际不符</p>',
      emCode: null,
      detectability: '1.0',
      severity: '3',
      fdpDeviceId: '17230100206|1#机组|278fc7db7eec4c8fadfc119bc67ec248',
      instanceDeviceCode: null,
      fdpDeviceName: '开入板',
      ord: '1#机组',
      display: 1,
      stationId: '17230100206',
      field: '保护',
      createUserName: null,
      updateUserName: null,
      faultAmount: 1,
      modelDeviceCode: 'SLJ007',
    },
    {
      createDept: '2000000134079',
      createTime: '2023-10-11 10:57:12',
      updateTime: '2023-10-12 00:00:26',
      status: -1,
      isDeleted: 0,
      id: '1711938974748106753',
      tenantId: '200000',
      fdpId: '17230100206|1#机组|6a784702762c4060a9e4eed63f3a3afe',
      fdpPartition: null,
      name: '蝶阀油压不足',
      info: '',
      emCode: null,
      detectability: '1.0',
      severity: '2',
      fdpDeviceId: '17230100206|1#机组|739599e544624f0880cd46b6474a585d',
      instanceDeviceCode: null,
      fdpDeviceName: '蝶阀',
      ord: '1#机组',
      display: 1,
      stationId: '17230100206',
      field: '主机及辅助设备',
      createUserName: null,
      updateUserName: null,
      faultAmount: 1,
      modelDeviceCode: 'SLJ008',
    },
    {
      createDept: '2000000134077',
      createTime: '2023-10-11 10:57:10',
      updateTime: '2023-10-12 00:00:09',
      status: -1,
      isDeleted: 0,
      id: '1711938965558386689',
      tenantId: '200000',
      fdpId: '17230100202|1#机组|42024d1994d34ebd8bd392598b428b40',
      fdpPartition: null,
      name: '信号传输通道故障',
      info: '<p>一般通过模拟量信号传输导叶位置信号。</p>',
      emCode: null,
      detectability: '1.0',
      severity: '1',
      fdpDeviceId: '17230100202|1#机组|df173f0617a84d918b4833500ac0c7c5',
      instanceDeviceCode: null,
      fdpDeviceName: '电气控制部分',
      ord: '1#机组',
      display: 1,
      stationId: '17230100202',
      field: '调速器',
      createUserName: null,
      updateUserName: null,
      faultAmount: null,
      modelDeviceCode: 'SLJ009',
    },
  ],
  total: 2,
  size: 9,
  current: 1,
  orders: [],
  optimizeCountSql: true,
  hitCount: false,
  searchCount: true,
  pages: 1,
};

//   故障待排查列表
const getNextstepData = {
  status: 0,
  code: 200,
  success: true,
  data: {
    data: {
      faults_checked: [
        {
          ORD: '2#机组上导',
          STATUS: '1.0',
          OCCURRENCE: '0.04',
          DEVICE_SHOWNAME: '2#机组上导',
          DEVICE_NAME: '上导',
          DETECTABILITY: '1.0',
          ID: '902100000026|2#机组上导|ebd132e4b2c643af9397bf18a1da5cba',
          INFO: '',
          DEVICE_ID: '902100000026|2#机组上导|a71b276cfcf54ce399ab203e11eb18de',
          CONFIDENCE: '1.0',
          NAME: '轴承温度整体升高',
          modelDeviceCode: 'SLJ002',
        },
      ],
      faults: [
        {
          ORD: '2#机组',
          OCCURRENCE: '0.02',
          DEVICE_SHOWNAME: '2#机组',
          DEVICE_NAME: '机组',
          DETECTABILITY: '1.0',
          SOLUTION: '',
          ID: '902100000026|2#机组|ad4da5c026f44e2f98e20f6027dbbfc5',
          INFO: '',
          DEVICE_ID: '902100000026|2#机组|741442f515564cc5921e0ee84fd4ea7e',
          CONFIDENCE: '0.27673325124035464',
          NAME: '机组冷却水中断或压力不足',
          modelDeviceCode: 'SLJ001',
        },
        {
          ORD: '2#机组上导',
          INSPECT: '检查各分支冷却水压力是否不正常，阀门是否无法正常打开',
          OCCURRENCE: '0.08',
          DEVICE_SHOWNAME: '2#机组上导',
          DEVICE_NAME: '上导',
          DETECTABILITY: '4.0',
          SOLUTION: '1、如果是阀门问题，维修或更换阀门。2、如果有堵塞，清理管道。',
          ID: '902100000026|2#机组上导|f6e2bd834a5f4c2f88405afaf7385977',
          INFO: '机组到冷却器之间的管道或者阀门故障',
          DEVICE_ID: '902100000026|2#机组上导|a71b276cfcf54ce399ab203e11eb18de',
          CONFIDENCE: '0.7319802819919283',
          NAME: '冷却水分支线路故障',
          modelDeviceCode: 'SLJ003',
        },
        {
          ORD: '2#机组',
          INSPECT: '到水泵控制箱处，就地控制水泵开关，看是否无法正常动作',
          OCCURRENCE: '0.03',
          DEVICE_SHOWNAME: '2#机组冷却水系统',
          DEVICE_NAME: '冷却水系统',
          DETECTABILITY: '2.0',
          SOLUTION: '对水泵电机、控制线路进行检修',
          ID: '902100000026|2#机组|594b42c20529468cbf36bda1005f911a',
          INFO: '<p>水泵无法工作</p>',
          DEVICE_ID: '902100000026|2#机组|7660c81b57bc472f9c1cf33e7c580275',
          CONFIDENCE: '0.07203767420730531',
          NAME: '水泵故障',
          modelDeviceCode: 'SLJ004',
        },
        {
          ORD: '2#机组上导',
          INSPECT: 'null',
          OCCURRENCE: '0.01',
          DEVICE_SHOWNAME: '2#机组上导',
          DEVICE_NAME: '上导',
          DETECTABILITY: '1.0',
          SOLUTION: 'null',
          ID: '902100000026|2#机组上导|60e63d42a69f40748f6496281dc0542f',
          INFO: '',
          DEVICE_ID: '902100000026|2#机组上导|a71b276cfcf54ce399ab203e11eb18de',
          CONFIDENCE: '0.03056255883046665',
          NAME: '示流器故障',
          modelDeviceCode: 'SLJ005',
        },
        {
          ORD: '2#机组上导',
          INSPECT:
            '1、油盆盖内环与大轴间隙过大 2、挡油环松动位移 3、油盆盖回油孔堵塞 4、油盆盖封油毛毡掉落',
          OCCURRENCE: '0.04',
          DEVICE_SHOWNAME: '2#机组上导',
          DEVICE_NAME: '上导',
          DETECTABILITY: '2.0',
          SOLUTION: '根据具体检查结果，采取对应措施',
          ID: '902100000026|2#机组上导|6d5f04a0162d41fdbeb5746e857257d0',
          INFO: '1、油盆盖内环与大轴间隙过大 2、挡油环松动位移 3、油盆盖回油孔堵塞 4、油盆盖封油毛毡掉落',
          DEVICE_ID: '902100000026|2#机组上导|a71b276cfcf54ce399ab203e11eb18de',
          CONFIDENCE: '0.04140223466993287',
          NAME: '轴承漏油或甩油',
          modelDeviceCode: 'SLJ006',
        },
        {
          ORD: '2#机组上导',
          INSPECT: '巡检时，检查上次换油记录，是否时间过长',
          OCCURRENCE: '0.04',
          DEVICE_SHOWNAME: '2#机组上导',
          DEVICE_NAME: '上导',
          DETECTABILITY: '2.0',
          SOLUTION: '及时换油即可',
          ID: '902100000026|2#机组上导|c2726d3330234f98a87c03d6320d80c6',
          INFO: '<p>轴承等油路需要定时维护保养，定时换油</p>',
          DEVICE_ID: '902100000026|2#机组上导|a71b276cfcf54ce399ab203e11eb18de',
          CONFIDENCE: '0.04112072766794106',
          NAME: '未及时换油',
          modelDeviceCode: 'SLJ007',
        },
        {
          ORD: '2#机组上导',
          INSPECT: 'null',
          OCCURRENCE: '0.01',
          DEVICE_SHOWNAME: '2#机组上导',
          DEVICE_NAME: '上导',
          DETECTABILITY: '1.0',
          SOLUTION: 'null',
          ID: '902100000026|2#机组上导|bb55d8a571ed4198b9f43a34e0d24b92',
          INFO: '',
          DEVICE_ID: '902100000026|2#机组上导|a71b276cfcf54ce399ab203e11eb18de',
          CONFIDENCE: '0.0103398750994524',
          NAME: '新加的油带水',
          modelDeviceCode: 'SLJ008',
        },
        {
          ORD: '2#机组上导',
          INSPECT: 'null',
          OCCURRENCE: '0.01',
          DEVICE_SHOWNAME: '2#机组上导',
          DEVICE_NAME: '上导',
          DETECTABILITY: '1.0',
          SOLUTION: 'null',
          ID: '902100000026|2#机组上导|d300b7ae06b642ad972928276e43061d',
          INFO: '',
          DEVICE_ID: '902100000026|2#机组上导|a71b276cfcf54ce399ab203e11eb18de',
          CONFIDENCE: '0.010095276665510534',
          NAME: '转子偏心',
          modelDeviceCode: 'SLJ002',
        },
        {
          ORD: '2#机组上导',
          INSPECT: '1、外循环系统检查外部液压站及油管 2、内循环系统检查机组本身油循环系统',
          OCCURRENCE: '0.02',
          DEVICE_SHOWNAME: '2#机组上导',
          DEVICE_NAME: '上导',
          DETECTABILITY: '2.0',
          SOLUTION: '维修或清洗油循环系统。',
          ID: '902100000026|2#机组上导|caa6cf276f0247d08458db0e8287ff87',
          INFO: '<p>是指有油循环系统的机组，润滑油在循环过程中出现问题，包括油泵、油路或润滑油等出现异常。</p>',
          DEVICE_ID: '902100000026|2#机组上导|a71b276cfcf54ce399ab203e11eb18de',
          CONFIDENCE: '0.020186850457355857',
          NAME: '油循环系统故障',
          modelDeviceCode: 'SLJ002',
        },
        {
          ORD: '2#机组',
          INSPECT: '如有振动监测装置，查看监测数据，或者通过听机组运行声音，分辨是否有异响。',
          OCCURRENCE: '0.01',
          DEVICE_SHOWNAME: '2#机组',
          DEVICE_NAME: '机组',
          DETECTABILITY: '2.0',
          SOLUTION: '',
          ID: '902100000026|2#机组|71822b57b73d487b9223bc3224d34719',
          INFO: '振动异常通常表现为机组震动、抖动、颤动等情况，振动频率、振动方向、振动幅度和振动形式等都可能有所不同。',
          DEVICE_ID: '902100000026|2#机组|741442f515564cc5921e0ee84fd4ea7e',
          CONFIDENCE: '0.010965505221036972',
          NAME: '振动异常',
          modelDeviceCode: 'SLJ002',
        },
        {
          ORD: '2#机组上导',
          OCCURRENCE: '0.08',
          BASEID: '902100000026|2#机组上导|66d4b3257b6842f69be2a5358e59c9c6',
          DEVICE_SHOWNAME: '2#机组上导',
          DEVICE_NAME: '上导',
          DETECTABILITY: '1.0',
          SOLUTION: '',
          ID: '902100000026|2#机组上导|3b1fa846672a48b096ccbc0707dc323b',
          INFO: '单个测温点温度异常升高',
          DEVICE_ID: '902100000026|2#机组上导|a71b276cfcf54ce399ab203e11eb18de',
          CONFIDENCE: '0.005240892585208624',
          NAME: '轴承温度单点升高',
          modelDeviceCode: 'SLJ002',
        },
        {
          ORD: '2#机组上导',
          INSPECT: '巡检时，检查上次加油记录，是否时间过长',
          OCCURRENCE: '0.01',
          DEVICE_SHOWNAME: '2#机组上导',
          DEVICE_NAME: '上导',
          DETECTABILITY: '2.0',
          SOLUTION: '及时加油即可',
          ID: '902100000026|2#机组上导|37d7175aeb5b46659b5ab37e7c486354',
          INFO: '<p>轴承等油路需要定时维护保养，加润滑油</p>',
          DEVICE_ID: '902100000026|2#机组上导|a71b276cfcf54ce399ab203e11eb18de',
          CONFIDENCE: '0.010356063671683645',
          NAME: '未及时加油',
          modelDeviceCode: 'SLJ002',
        },
        {
          ORD: '2#机组上导',
          INSPECT: '对轴承进行绝缘实验，是否绝缘过低',
          OCCURRENCE: '0.02',
          DEVICE_SHOWNAME: '2#机组上导',
          DEVICE_NAME: '上导',
          DETECTABILITY: '8.0',
          SOLUTION: '1、清洗或更换绝缘板 2、检查是否有油污或金属接触绝缘板两端',
          ID: '902100000026|2#机组上导|fa97487eb62e40dc97e46c6f2ff478ff',
          INFO: '<p>轴承绝缘目的是为了避轴端电压形成短路，产生短路电流，而短路电流会烧伤轴，和轴承接触面。</p>',
          DEVICE_ID: '902100000026|2#机组上导|a71b276cfcf54ce399ab203e11eb18de',
          CONFIDENCE: '0.020571613237246496',
          NAME: '轴承绝缘不良',
          modelDeviceCode: 'SLJ002',
        },
        {
          ORD: '2#机组上导',
          INSPECT: '停机检修，检查瓦块状态。',
          OCCURRENCE: '0.01',
          DEVICE_SHOWNAME: '2#机组上导',
          DEVICE_NAME: '上导',
          DETECTABILITY: '24.0',
          SOLUTION: '维修或更换瓦块。',
          ID: '902100000026|2#机组上导|66d4b3257b6842f69be2a5358e59c9c6',
          INFO: '包括瓦面磨损、灵活性受卡阻、受力调整不均匀、瓦质量不良或变形过大等',
          DEVICE_ID: '902100000026|2#机组上导|a71b276cfcf54ce399ab203e11eb18de',
          CONFIDENCE: '0.010481785170417248',
          NAME: '瓦块损坏或调整不当',
          modelDeviceCode: 'SLJ002',
        },
      ],
      treedata: {
        ORD: '2#机组上导',
        ISROOT: 0,
        DEVICE_NAME: '上导',
        DETECTABILITY: '1.0',
        INFO: '',
        DSTYLE: 2,
        STATUS: '1.0',
        DISPLAY: 1,
        AMOUNT: 1,
        OCCURRENCE: '0.04',
        children: [
          {
            ORD: '2#机组上导',
            ISROOT: 0,
            DEVICE_NAME: '上导',
            DETECTABILITY: '1.0',
            INFO: '',
            DSTYLE: 2,
            STATUS: '1.0',
            DISPLAY: 1,
            AMOUNT: 1,
            OCCURRENCE: '0.06',
            children: [
              {
                ORD: '2#机组上导',
                INSPECT: '检查各分支冷却水压力是否不正常，阀门是否无法正常打开',
                ISROOT: 1,
                DEVICE_NAME: '上导',
                DETECTABILITY: '4.0',
                INFO: '机组到冷却器之间的管道或者阀门故障',
                DSTYLE: 2,
                STATUS: -1,
                DISPLAY: 1,
                AMOUNT: 1,
                OCCURRENCE: '0.08',
                DEVICE_SHOWNAME: '2#机组上导',
                GRAPH_NAME: '水电站知识图谱',
                PARTITION: 41602,
                ID: '902100000026|2#机组上导|f6e2bd834a5f4c2f88405afaf7385977',
                CONFIDENCE: '0.7319802819919283',
                TAOS_INSTANCE: 'HZ112',
                STATION: '902100000026',
                FIELD: '主机及辅助设备',
                GRAPH_ID: '4a642326590549dea51c0599a01eccba',
                SOLUTION: '1、如果是阀门问题，维修或更换阀门。2、如果有堵塞，清理管道。',
                SHUTDOWN_DETECT: 0,
                NAME: '冷却水分支线路故障',
                SHUTDOWN_DETECTE: '0',
                FATHER: 'f6e2bd834a5f4c2f88405afaf7385977',
                DEVICE_ID: '902100000026|2#机组上导|a71b276cfcf54ce399ab203e11eb18de',
                SEVERITY: 2,
              },
              {
                ORD: '2#机组',
                ISROOT: 0,
                DEVICE_NAME: '机组',
                DETECTABILITY: '1.0',
                INFO: '',
                DSTYLE: 2,
                STATUS: -1,
                DISPLAY: 1,
                AMOUNT: 1,
                OCCURRENCE: '0.02',
                children: [
                  {
                    ORD: '2#机组',
                    INSPECT:
                      '停机检查，对冷却水上各个阀门进行开关处理，是否存在故障无法开关动作的情况。',
                    ISROOT: 1,
                    DEVICE_NAME: '机组',
                    DETECTABILITY: '1.0',
                    INFO: '总管到机组之间的管道或者阀门故障',
                    DSTYLE: 2,
                    STATUS: -1,
                    DISPLAY: 1,
                    AMOUNT: 1,
                    OCCURRENCE: '0.04',
                    DEVICE_SHOWNAME: '2#机组',
                    GRAPH_NAME: '水电站知识图谱',
                    PARTITION: 41602,
                    ID: '902100000026|2#机组|441f7e6bd5044470955c8af360804e7a',
                    CONFIDENCE: '0.23854780001488637',
                    TAOS_INSTANCE: 'HZ112',
                    STATION: '902100000026',
                    FIELD: '主机及辅助设备',
                    SOLUTION: '如果阀门损坏，检修或更换阀门。',
                    GRAPH_ID: '4a642326590549dea51c0599a01eccba',
                    SHUTDOWN_DETECT: 0,
                    NAME: '机组冷却水线路故障',
                    SHUTDOWN_DETECTE: '0',
                    FATHER: '441f7e6bd5044470955c8af360804e7a',
                    DEVICE_ID: '902100000026|2#机组|741442f515564cc5921e0ee84fd4ea7e',
                    SEVERITY: 3,
                  },
                  {
                    ORD: '2#机组',
                    INSPECT: '到水泵控制箱处，就地控制水泵开关，看是否无法正常动作',
                    ISROOT: 1,
                    DEVICE_NAME: '冷却水系统',
                    DETECTABILITY: '2.0',
                    INFO: '<p>水泵无法工作</p>',
                    DSTYLE: 2,
                    STATUS: -1,
                    DISPLAY: 0,
                    AMOUNT: 1,
                    OCCURRENCE: '0.03',
                    DEVICE_SHOWNAME: '2#机组冷却水系统',
                    GRAPH_NAME: '水电站知识图谱',
                    PARTITION: 41602,
                    ID: '902100000026|2#机组|594b42c20529468cbf36bda1005f911a',
                    CONFIDENCE: '0.07203767420730531',
                    TAOS_INSTANCE: 'HZ112',
                    STATION: '902100000026',
                    FIELD: '主机及辅助设备',
                    GRAPH_ID: '4a642326590549dea51c0599a01eccba',
                    SOLUTION: '对水泵电机、控制线路进行检修',
                    SHUTDOWN_DETECT: 0,
                    NAME: '水泵故障',
                    SHUTDOWN_DETECTE: '0',
                    FATHER: '594b42c20529468cbf36bda1005f911a',
                    DEVICE_ID: '902100000026|2#机组|7660c81b57bc472f9c1cf33e7c580275',
                    SEVERITY: 2,
                  },
                ],
                DEVICE_SHOWNAME: '2#机组',
                GRAPH_NAME: '水电站知识图谱',
                PARTITION: 41602,
                ID: '902100000026|2#机组|ad4da5c026f44e2f98e20f6027dbbfc5',
                CONFIDENCE: '0.27673325124035464',
                TAOS_INSTANCE: 'HZ112',
                STATION: '902100000026',
                FIELD: '主机及辅助设备',
                GRAPH_ID: '4a642326590549dea51c0599a01eccba',
                SOLUTION: '',
                SHUTDOWN_DETECT: 0,
                NAME: '机组冷却水中断或压力不足',
                SHUTDOWN_DETECTE: '0',
                FATHER: 'ad4da5c026f44e2f98e20f6027dbbfc5',
                DEVICE_ID: '902100000026|2#机组|741442f515564cc5921e0ee84fd4ea7e',
                SEVERITY: 3,
              },
              {
                ORD: '2#机组上导',
                INSPECT: 'null',
                ISROOT: 1,
                DEVICE_NAME: '上导',
                DETECTABILITY: '1.0',
                INFO: '',
                DSTYLE: 2,
                STATUS: -1,
                DISPLAY: 1,
                AMOUNT: 1,
                OCCURRENCE: '0.01',
                DEVICE_SHOWNAME: '2#机组上导',
                GRAPH_NAME: '水电站知识图谱',
                PARTITION: 41602,
                ID: '902100000026|2#机组上导|60e63d42a69f40748f6496281dc0542f',
                CONFIDENCE: '0.03056255883046665',
                TAOS_INSTANCE: 'HZ112',
                STATION: '902100000026',
                FIELD: '主机及辅助设备',
                SOLUTION: 'null',
                GRAPH_ID: '4a642326590549dea51c0599a01eccba',
                SHUTDOWN_DETECT: 0,
                NAME: '示流器故障',
                FATHER: '60e63d42a69f40748f6496281dc0542f',
                DEVICE_ID: '902100000026|2#机组上导|a71b276cfcf54ce399ab203e11eb18de',
                SEVERITY: 1,
              },
            ],
            DEVICE_SHOWNAME: '2#机组上导',
            GRAPH_NAME: '水电站知识图谱',
            PARTITION: 41602,
            ID: '902100000026|2#机组上导|b875a14ad88b43c7b86bc30398e7dcf6',
            CONFIDENCE: '1.0',
            TAOS_INSTANCE: 'HZ112',
            STATION: '902100000026',
            FIELD: '主机及辅助设备',
            GRAPH_ID: '4a642326590549dea51c0599a01eccba',
            SOLUTION: '',
            SHUTDOWN_DETECT: 0,
            NAME: '轴承冷却水中断或水压不足',
            SHUTDOWN_DETECTE: '0',
            FATHER: 'b875a14ad88b43c7b86bc30398e7dcf6',
            DEVICE_ID: '902100000026|2#机组上导|a71b276cfcf54ce399ab203e11eb18de',
            SEVERITY: 2,
          },
          {
            ORD: '2#机组上导',
            ISROOT: 0,
            DEVICE_NAME: '上导',
            DETECTABILITY: '4.0',
            INFO: '',
            DSTYLE: 2,
            STATUS: -1,
            DISPLAY: 1,
            AMOUNT: 1,
            OCCURRENCE: '0.04',
            children: [
              {
                ORD: '2#机组上导',
                INSPECT: '巡检时，检查上次换油记录，是否时间过长',
                ISROOT: 1,
                DEVICE_NAME: '上导',
                DETECTABILITY: '2.0',
                INFO: '<p>轴承等油路需要定时维护保养，定时换油</p>',
                DSTYLE: 3,
                STATUS: -1,
                DISPLAY: 0,
                AMOUNT: 1,
                OCCURRENCE: '0.04',
                DEVICE_SHOWNAME: '2#机组上导',
                GRAPH_NAME: '水电站知识图谱',
                PARTITION: 41602,
                ID: '902100000026|2#机组上导|c2726d3330234f98a87c03d6320d80c6',
                CONFIDENCE: '0.04112072766794106',
                TAOS_INSTANCE: 'HZ112',
                STATION: '902100000026',
                FIELD: '主机及辅助设备',
                SOLUTION: '及时换油即可',
                GRAPH_ID: '4a642326590549dea51c0599a01eccba',
                SHUTDOWN_DETECT: 0,
                NAME: '未及时换油',
                SHUTDOWN_DETECTE: '0',
                FATHER: 'c2726d3330234f98a87c03d6320d80c6',
                DEVICE_ID: '902100000026|2#机组上导|a71b276cfcf54ce399ab203e11eb18de',
                SEVERITY: 2,
              },
              {
                ORD: '2#机组上导',
                INSPECT: '1、外循环系统检查外部液压站及油管 2、内循环系统检查机组本身油循环系统',
                ISROOT: 1,
                DEVICE_NAME: '上导',
                DETECTABILITY: '2.0',
                INFO: '<p>是指有油循环系统的机组，润滑油在循环过程中出现问题，包括油泵、油路或润滑油等出现异常。</p>',
                DSTYLE: 2,
                STATUS: -1,
                DISPLAY: 1,
                AMOUNT: 1,
                OCCURRENCE: '0.02',
                DEVICE_SHOWNAME: '2#机组上导',
                GRAPH_NAME: '水电站知识图谱',
                PARTITION: 41602,
                ID: '902100000026|2#机组上导|caa6cf276f0247d08458db0e8287ff87',
                CONFIDENCE: '0.020186850457355857',
                TAOS_INSTANCE: 'HZ112',
                STATION: '902100000026',
                FIELD: '主机及辅助设备',
                GRAPH_ID: '4a642326590549dea51c0599a01eccba',
                SOLUTION: '维修或清洗油循环系统。',
                SHUTDOWN_DETECT: 0,
                NAME: '油循环系统故障',
                SHUTDOWN_DETECTE: '0',
                FATHER: 'caa6cf276f0247d08458db0e8287ff87',
                DEVICE_ID: '902100000026|2#机组上导|a71b276cfcf54ce399ab203e11eb18de',
                SEVERITY: 2,
              },
              {
                ORD: '2#机组上导',
                INSPECT: '检查润滑油油质',
                ISROOT: 0,
                DEVICE_NAME: '上导',
                DETECTABILITY: '4.0',
                INFO: '轴承润滑油中混入水分',
                DSTYLE: 2,
                STATUS: -1,
                DISPLAY: 1,
                AMOUNT: 1,
                OCCURRENCE: '0.02',
                children: [
                  {
                    ORD: '2#机组上导',
                    INSPECT: 'null',
                    ISROOT: 1,
                    DEVICE_NAME: '上导',
                    DETECTABILITY: '1.0',
                    INFO: '',
                    DSTYLE: 2,
                    STATUS: -1,
                    DISPLAY: 1,
                    AMOUNT: 1,
                    OCCURRENCE: '0.01',
                    DEVICE_SHOWNAME: '2#机组上导',
                    GRAPH_NAME: '水电站知识图谱',
                    PARTITION: 41602,
                    ID: '902100000026|2#机组上导|bb55d8a571ed4198b9f43a34e0d24b92',
                    CONFIDENCE: '0.0103398750994524',
                    TAOS_INSTANCE: 'HZ112',
                    STATION: '902100000026',
                    FIELD: '主机及辅助设备',
                    SOLUTION: 'null',
                    GRAPH_ID: '4a642326590549dea51c0599a01eccba',
                    SHUTDOWN_DETECT: 0,
                    NAME: '新加的油带水',
                    FATHER: 'bb55d8a571ed4198b9f43a34e0d24b92',
                    DEVICE_ID: '902100000026|2#机组上导|a71b276cfcf54ce399ab203e11eb18de',
                    SEVERITY: 1,
                  },
                  {
                    ORD: '2#机组上导',
                    INSPECT: '检查冷却器水箱是否减少',
                    ISROOT: 1,
                    DEVICE_NAME: '上导',
                    DETECTABILITY: '4.0',
                    INFO: '冷却器漏水可能导致水混到油中',
                    DSTYLE: 2,
                    STATUS: '0.0',
                    DISPLAY: 0,
                    AMOUNT: 1,
                    OCCURRENCE: '0.04',
                    DEVICE_SHOWNAME: '2#机组上导',
                    GRAPH_NAME: '水电站知识图谱',
                    PARTITION: 41602,
                    ID: '902100000026|2#机组上导|b504c271316548da9f8c9500520693c7',
                    CONFIDENCE: '0.0',
                    TAOS_INSTANCE: 'HZ112',
                    STATION: '902100000026',
                    FIELD: '主机及辅助设备',
                    SOLUTION: '进行维修补漏',
                    GRAPH_ID: '4a642326590549dea51c0599a01eccba',
                    SHUTDOWN_DETECT: 0,
                    NAME: '冷却器漏水',
                    SHUTDOWN_DETECTE: '0',
                    FATHER: 'b504c271316548da9f8c9500520693c7',
                    DEVICE_ID: '902100000026|2#机组上导|a71b276cfcf54ce399ab203e11eb18de',
                    SEVERITY: 2,
                  },
                ],
                DEVICE_SHOWNAME: '2#机组上导',
                GRAPH_NAME: '水电站知识图谱',
                PARTITION: 41602,
                ID: '902100000026|2#机组上导|46bd78a594da4993a5bd74e2c04c972f',
                CONFIDENCE: '0.0023426215649025193',
                TAOS_INSTANCE: 'HZ112',
                STATION: '902100000026',
                FIELD: '主机及辅助设备',
                SOLUTION: '更换油箱中的润滑油，并检查冷却器相关部位，避免再次漏水',
                GRAPH_ID: '4a642326590549dea51c0599a01eccba',
                SHUTDOWN_DETECT: 0,
                NAME: '轴承油混水',
                SHUTDOWN_DETECTE: '0',
                FATHER: '46bd78a594da4993a5bd74e2c04c972f',
                DEVICE_ID: '902100000026|2#机组上导|a71b276cfcf54ce399ab203e11eb18de',
                SEVERITY: 2,
              },
            ],
            DEVICE_SHOWNAME: '2#机组上导',
            GRAPH_NAME: '水电站知识图谱',
            PARTITION: 41602,
            ID: '902100000026|2#机组上导|274b320d49c24805bb61946d94552160',
            CONFIDENCE: '0.029458970990772472',
            TAOS_INSTANCE: 'HZ112',
            STATION: '902100000026',
            FIELD: '主机及辅助设备',
            SOLUTION: '',
            GRAPH_ID: '4a642326590549dea51c0599a01eccba',
            SHUTDOWN_DETECT: 0,
            NAME: '油质劣化',
            SHUTDOWN_DETECTE: '0',
            FATHER: '274b320d49c24805bb61946d94552160',
            DEVICE_ID: '902100000026|2#机组上导|a71b276cfcf54ce399ab203e11eb18de',
            SEVERITY: 2,
          },
          {
            ORD: '2#机组上导',
            ISROOT: 0,
            DEVICE_NAME: '上导',
            DETECTABILITY: '1.0',
            INFO: '',
            DSTYLE: 2,
            STATUS: -1,
            DISPLAY: 1,
            AMOUNT: 1,
            OCCURRENCE: '0.06',
            children: [
              {
                ORD: '2#机组上导',
                INSPECT:
                  '1、油盆盖内环与大轴间隙过大 2、挡油环松动位移 3、油盆盖回油孔堵塞 4、油盆盖封油毛毡掉落',
                ISROOT: 1,
                DEVICE_NAME: '上导',
                DETECTABILITY: '2.0',
                INFO: '1、油盆盖内环与大轴间隙过大 2、挡油环松动位移 3、油盆盖回油孔堵塞 4、油盆盖封油毛毡掉落',
                DSTYLE: 2,
                STATUS: -1,
                DISPLAY: 1,
                AMOUNT: 1,
                OCCURRENCE: '0.04',
                DEVICE_SHOWNAME: '2#机组上导',
                GRAPH_NAME: '水电站知识图谱',
                PARTITION: 41602,
                ID: '902100000026|2#机组上导|6d5f04a0162d41fdbeb5746e857257d0',
                CONFIDENCE: '0.04140223466993287',
                TAOS_INSTANCE: 'HZ112',
                STATION: '902100000026',
                FIELD: '主机及辅助设备',
                GRAPH_ID: '4a642326590549dea51c0599a01eccba',
                SOLUTION: '根据具体检查结果，采取对应措施',
                SHUTDOWN_DETECT: 0,
                NAME: '轴承漏油或甩油',
                SHUTDOWN_DETECTE: '0',
                FATHER: '6d5f04a0162d41fdbeb5746e857257d0',
                DEVICE_ID: '902100000026|2#机组上导|a71b276cfcf54ce399ab203e11eb18de',
                SEVERITY: 2,
              },
              {
                ORD: '2#机组上导',
                INSPECT: '巡检时，检查上次加油记录，是否时间过长',
                ISROOT: 1,
                DEVICE_NAME: '上导',
                DETECTABILITY: '2.0',
                INFO: '<p>轴承等油路需要定时维护保养，加润滑油</p>',
                DSTYLE: 2,
                STATUS: -1,
                DISPLAY: 1,
                AMOUNT: 1,
                OCCURRENCE: '0.01',
                DEVICE_SHOWNAME: '2#机组上导',
                GRAPH_NAME: '水电站知识图谱',
                PARTITION: 41602,
                ID: '902100000026|2#机组上导|37d7175aeb5b46659b5ab37e7c486354',
                CONFIDENCE: '0.010356063671683645',
                TAOS_INSTANCE: 'HZ112',
                STATION: '902100000026',
                FIELD: '主机及辅助设备',
                SOLUTION: '及时加油即可',
                GRAPH_ID: '4a642326590549dea51c0599a01eccba',
                SHUTDOWN_DETECT: 0,
                NAME: '未及时加油',
                SHUTDOWN_DETECTE: '0',
                FATHER: '37d7175aeb5b46659b5ab37e7c486354',
                DEVICE_ID: '902100000026|2#机组上导|a71b276cfcf54ce399ab203e11eb18de',
                SEVERITY: 2,
              },
            ],
            DEVICE_SHOWNAME: '2#机组上导',
            GRAPH_NAME: '水电站知识图谱',
            PARTITION: 41602,
            ID: '902100000026|2#机组上导|4890d37fdaa74f3b800adae52a5d45c6',
            CONFIDENCE: '0.026682152625817798',
            TAOS_INSTANCE: 'HZ112',
            STATION: '902100000026',
            FIELD: '主机及辅助设备',
            SOLUTION: '',
            GRAPH_ID: '4a642326590549dea51c0599a01eccba',
            SHUTDOWN_DETECT: 0,
            NAME: '油位下降',
            SHUTDOWN_DETECTE: '0',
            FATHER: '4890d37fdaa74f3b800adae52a5d45c6',
            DEVICE_ID: '902100000026|2#机组上导|a71b276cfcf54ce399ab203e11eb18de',
            SEVERITY: 3,
          },
          {
            ORD: '2#机组上导',
            INSPECT: '查看轴电流数据',
            ISROOT: 0,
            DEVICE_NAME: '上导',
            DETECTABILITY: '4.0',
            INFO: '<p>机组主轴在不对称磁场中旋转，会在其两端产生交流电压，即轴电压。如果主轴两端轴承没有绝缘，轴电压就会通过两端支架形成轴电流。</p>',
            DSTYLE: 2,
            STATUS: -1,
            DISPLAY: 1,
            AMOUNT: 1,
            OCCURRENCE: '0.02',
            children: [
              {
                ORD: '2#机组上导',
                INSPECT: '对轴承进行绝缘实验，是否绝缘过低',
                ISROOT: 1,
                DEVICE_NAME: '上导',
                DETECTABILITY: '8.0',
                INFO: '<p>轴承绝缘目的是为了避轴端电压形成短路，产生短路电流，而短路电流会烧伤轴，和轴承接触面。</p>',
                DSTYLE: 0,
                STATUS: -1,
                DISPLAY: 0,
                AMOUNT: 1,
                OCCURRENCE: '0.02',
                DEVICE_SHOWNAME: '2#机组上导',
                GRAPH_NAME: '水电站知识图谱',
                PARTITION: 41602,
                ID: '902100000026|2#机组上导|fa97487eb62e40dc97e46c6f2ff478ff',
                CONFIDENCE: '0.020571613237246496',
                TAOS_INSTANCE: 'HZ112',
                STATION: '902100000026',
                FIELD: '主机及辅助设备',
                SOLUTION: '1、清洗或更换绝缘板 2、检查是否有油污或金属接触绝缘板两端',
                GRAPH_ID: '4a642326590549dea51c0599a01eccba',
                SHUTDOWN_DETECT: 0,
                NAME: '轴承绝缘不良',
                SHUTDOWN_DETECTE: '0',
                FATHER: 'fa97487eb62e40dc97e46c6f2ff478ff',
                DEVICE_ID: '902100000026|2#机组上导|a71b276cfcf54ce399ab203e11eb18de',
                SEVERITY: 2,
              },
              {
                ORD: '2#机组上导',
                INSPECT: 'null',
                ISROOT: 1,
                DEVICE_NAME: '上导',
                DETECTABILITY: '1.0',
                INFO: '',
                DSTYLE: 2,
                STATUS: -1,
                DISPLAY: 1,
                AMOUNT: 1,
                OCCURRENCE: '0.01',
                DEVICE_SHOWNAME: '2#机组上导',
                GRAPH_NAME: '水电站知识图谱',
                PARTITION: 41602,
                ID: '902100000026|2#机组上导|d300b7ae06b642ad972928276e43061d',
                CONFIDENCE: '0.010095276665510534',
                TAOS_INSTANCE: 'HZ112',
                STATION: '902100000026',
                FIELD: '主机及辅助设备',
                SOLUTION: 'null',
                GRAPH_ID: '4a642326590549dea51c0599a01eccba',
                SHUTDOWN_DETECT: 0,
                NAME: '转子偏心',
                FATHER: 'd300b7ae06b642ad972928276e43061d',
                DEVICE_ID: '902100000026|2#机组上导|a71b276cfcf54ce399ab203e11eb18de',
                SEVERITY: 1,
              },
            ],
            DEVICE_SHOWNAME: '2#机组上导',
            GRAPH_NAME: '水电站知识图谱',
            PARTITION: 41602,
            ID: '902100000026|2#机组上导|86a95cfe544e4fd2a015a735e23860aa',
            CONFIDENCE: '0.014647173486778225',
            TAOS_INSTANCE: 'HZ112',
            STATION: '902100000026',
            FIELD: '主机及辅助设备',
            SOLUTION:
              '从大轴接地、润滑油介质、受油器绝缘、轴承座与支架的绝缘等多方面进行检查，从根本上消除轴电流形成的途径',
            GRAPH_ID: '4a642326590549dea51c0599a01eccba',
            SHUTDOWN_DETECT: 0,
            NAME: '轴电流升高',
            SHUTDOWN_DETECTE: '0',
            FATHER: '86a95cfe544e4fd2a015a735e23860aa',
            DEVICE_ID: '902100000026|2#机组上导|a71b276cfcf54ce399ab203e11eb18de',
            SEVERITY: 2,
          },
          {
            ORD: '2#机组',
            INSPECT: '如有振动监测装置，查看监测数据，或者通过听机组运行声音，分辨是否有异响。',
            ISROOT: 1,
            DEVICE_NAME: '机组',
            DETECTABILITY: '2.0',
            INFO: '振动异常通常表现为机组震动、抖动、颤动等情况，振动频率、振动方向、振动幅度和振动形式等都可能有所不同。',
            DSTYLE: 2,
            STATUS: -1,
            DISPLAY: 1,
            AMOUNT: 1,
            OCCURRENCE: '0.01',
            DEVICE_SHOWNAME: '2#机组',
            GRAPH_NAME: '水电站知识图谱',
            PARTITION: 41602,
            ID: '902100000026|2#机组|71822b57b73d487b9223bc3224d34719',
            CONFIDENCE: '0.010965505221036972',
            TAOS_INSTANCE: 'HZ112',
            STATION: '902100000026',
            FIELD: '主机及辅助设备',
            GRAPH_ID: '4a642326590549dea51c0599a01eccba',
            SOLUTION: '',
            SHUTDOWN_DETECT: 0,
            NAME: '振动异常',
            SHUTDOWN_DETECTE: '0',
            FATHER: '71822b57b73d487b9223bc3224d34719',
            DEVICE_ID: '902100000026|2#机组|741442f515564cc5921e0ee84fd4ea7e',
            SEVERITY: 3,
          },
          {
            ORD: '2#机组上导',
            INSPECT: '停机检修，检查瓦块状态。',
            ISROOT: 1,
            DEVICE_NAME: '上导',
            DETECTABILITY: '24.0',
            INFO: '包括瓦面磨损、灵活性受卡阻、受力调整不均匀、瓦质量不良或变形过大等',
            DSTYLE: 3,
            STATUS: -1,
            DISPLAY: 0,
            AMOUNT: 1,
            OCCURRENCE: '0.01',
            DEVICE_SHOWNAME: '2#机组上导',
            GRAPH_NAME: '水电站知识图谱',
            PARTITION: 41602,
            ID: '902100000026|2#机组上导|66d4b3257b6842f69be2a5358e59c9c6',
            CONFIDENCE: '0.010481785170417248',
            TAOS_INSTANCE: 'HZ112',
            STATION: '902100000026',
            FIELD: '主机及辅助设备',
            SOLUTION: '维修或更换瓦块。',
            GRAPH_ID: '4a642326590549dea51c0599a01eccba',
            SHUTDOWN_DETECT: 0,
            NAME: '瓦块损坏或调整不当',
            SHUTDOWN_DETECTE: '0',
            FATHER: '66d4b3257b6842f69be2a5358e59c9c6',
            DEVICE_ID: '902100000026|2#机组上导|a71b276cfcf54ce399ab203e11eb18de',
            SEVERITY: 3,
          },
          {
            ORD: '2#机组上导',
            INSPECT: '检查润滑油油质',
            ISROOT: 0,
            DEVICE_NAME: '上导',
            DETECTABILITY: '4.0',
            INFO: '轴承润滑油中混入水分',
            DSTYLE: 2,
            STATUS: -1,
            DISPLAY: 1,
            AMOUNT: 1,
            OCCURRENCE: '0.02',
            children: [
              {
                ORD: '2#机组上导',
                INSPECT: 'null',
                ISROOT: 1,
                DEVICE_NAME: '上导',
                DETECTABILITY: '1.0',
                INFO: '',
                DSTYLE: 2,
                STATUS: -1,
                DISPLAY: 1,
                AMOUNT: 1,
                OCCURRENCE: '0.01',
                DEVICE_SHOWNAME: '2#机组上导',
                GRAPH_NAME: '水电站知识图谱',
                PARTITION: 41602,
                ID: '902100000026|2#机组上导|bb55d8a571ed4198b9f43a34e0d24b92',
                CONFIDENCE: '0.0103398750994524',
                TAOS_INSTANCE: 'HZ112',
                STATION: '902100000026',
                FIELD: '主机及辅助设备',
                SOLUTION: 'null',
                GRAPH_ID: '4a642326590549dea51c0599a01eccba',
                SHUTDOWN_DETECT: 0,
                NAME: '新加的油带水',
                FATHER: 'bb55d8a571ed4198b9f43a34e0d24b92',
                DEVICE_ID: '902100000026|2#机组上导|a71b276cfcf54ce399ab203e11eb18de',
                SEVERITY: 1,
              },
              {
                ORD: '2#机组上导',
                INSPECT: '检查冷却器水箱是否减少',
                ISROOT: 1,
                DEVICE_NAME: '上导',
                DETECTABILITY: '4.0',
                INFO: '冷却器漏水可能导致水混到油中',
                DSTYLE: 2,
                STATUS: '0.0',
                DISPLAY: 0,
                AMOUNT: 1,
                OCCURRENCE: '0.04',
                DEVICE_SHOWNAME: '2#机组上导',
                GRAPH_NAME: '水电站知识图谱',
                PARTITION: 41602,
                ID: '902100000026|2#机组上导|b504c271316548da9f8c9500520693c7',
                CONFIDENCE: '0.0',
                TAOS_INSTANCE: 'HZ112',
                STATION: '902100000026',
                FIELD: '主机及辅助设备',
                SOLUTION: '进行维修补漏',
                GRAPH_ID: '4a642326590549dea51c0599a01eccba',
                SHUTDOWN_DETECT: 0,
                NAME: '冷却器漏水',
                SHUTDOWN_DETECTE: '0',
                FATHER: 'b504c271316548da9f8c9500520693c7',
                DEVICE_ID: '902100000026|2#机组上导|a71b276cfcf54ce399ab203e11eb18de',
                SEVERITY: 2,
              },
            ],
            DEVICE_SHOWNAME: '2#机组上导',
            GRAPH_NAME: '水电站知识图谱',
            PARTITION: 41602,
            ID: '902100000026|2#机组上导|46bd78a594da4993a5bd74e2c04c972f',
            CONFIDENCE: '0.0023426215649025193',
            TAOS_INSTANCE: 'HZ112',
            STATION: '902100000026',
            FIELD: '主机及辅助设备',
            SOLUTION: '更换油箱中的润滑油，并检查冷却器相关部位，避免再次漏水',
            GRAPH_ID: '4a642326590549dea51c0599a01eccba',
            SHUTDOWN_DETECT: 0,
            NAME: '轴承油混水',
            SHUTDOWN_DETECTE: '0',
            FATHER: '46bd78a594da4993a5bd74e2c04c972f',
            DEVICE_ID: '902100000026|2#机组上导|a71b276cfcf54ce399ab203e11eb18de',
            SEVERITY: 2,
          },
        ],
        DEVICE_SHOWNAME: '2#机组上导',
        GRAPH_NAME: '水电站知识图谱',
        PARTITION: 41602,
        ID: '902100000026|2#机组上导|ebd132e4b2c643af9397bf18a1da5cba',
        CONFIDENCE: '1.0',
        TAOS_INSTANCE: 'HZ112',
        STATION: '902100000026',
        FIELD: '主机及辅助设备',
        GRAPH_ID: '4a642326590549dea51c0599a01eccba',
        SOLUTION: '',
        SHUTDOWN_DETECT: 0,
        NAME: '轴承温度整体升高',
        SHUTDOWN_DETECTE: '0',
        FATHER: 'ebd132e4b2c643af9397bf18a1da5cba',
        DEVICE_ID: '902100000026|2#机组上导|a71b276cfcf54ce399ab203e11eb18de',
        SEVERITY: 3,
      },
    },
    message: '诊断成功',
    status: 4,
  },
  msg: '获取信息成功',
};

// 查询状态
const searchFaultStateByFaul = {
  status: 0,
  code: 200,
  success: true,
  data: [
    {
      id: '902100000026|3#机组水导|66d4b3257b6842f69be2a5358e59c9c6',
      name: '瓦块损坏或调整不当',
      status: '1.0',
      createTime: '2023-09-22 09:33:03',
      createUser: '',
      lifeTime: '72.0',
      info: '',
      priority: '2',
      source: 'manual',
      taskId: '1705031825115627522',
      deleteTime: null,
    },
  ],
  msg: null,
};

// 修改状态
const updateFaultState = {
  taskId: '1705031825115627522',
  confidence: 0.7,
  info: '-',
  faultId: '902100000026|3#机组水导|66d4b3257b6842f69be2a5358e59c9c6',
  stationId: '902100000026',
  isDeleted: 0,
};

// 视频流列表
const videoLIst = [
  {
    createDept: '2000000134006',
    createTime: '2023-10-07 17:16:00',
    updateTime: '2023-10-10 20:46:38',
    status: 1,
    isDeleted: 0,
    id: '1710584747991760898',
    tenantId: '200000',
    name: '高板岩二站厂房右侧',
    stationId: '901901000019',
    deptId: 2000000134006,
    isHikvideo: 1,
    type: '3',
    videoType: '1',
    liveSourceAddress: 'http://172.30.100.204:8950/openUrl/IHJzL5S/live.flv',
    pointCode: '2e76b4085047487fb4a3f986ee723152',
    videoHost: '172.30.100.204:443',
    appKey: '22969597',
    appSecret: 'MjEVUaU2a7K2aG85sEPU',
    sort: 1,
  },
  {
    createDept: '2000000134006',
    createTime: '2023-10-07 17:17:13',
    updateTime: '2023-10-07 17:17:13',
    status: 1,
    isDeleted: 0,
    id: '1710585054113038338',
    tenantId: '200000',
    name: '高板二站厂房左侧',
    stationId: '901901000019',
    deptId: 2000000134006,
    isHikvideo: 1,
    type: '3',
    videoType: '1',
    liveSourceAddress: 'http://172.30.100.204:8950/openUrl/II2ASOc/live.flv',
    pointCode: '4b611343266a43b8be812f7200bcbad8',
    videoHost: '172.30.100.204:443',
    appKey: '22969597',
    appSecret: 'MjEVUaU2a7K2aG85sEPU',
    sort: 2,
  },
  {
    createDept: '2000000134006',
    createTime: '2023-10-07 17:17:42',
    updateTime: '2023-10-07 17:17:42',
    status: 1,
    isDeleted: 0,
    id: '1710585175336812546',
    tenantId: '200000',
    name: '高板岩二站厂房全景球机',
    stationId: '901901000019',
    deptId: 2000000134006,
    isHikvideo: 1,
    type: '3',
    videoType: '1',
    liveSourceAddress: 'http://172.30.100.204:8950/openUrl/IIlkpos/live.flv',
    pointCode: '7a204d4a5a2d4a26a2d9eb183079c88b',
    videoHost: '172.30.100.204:443',
    appKey: '22969597',
    appSecret: 'MjEVUaU2a7K2aG85sEPU',
    sort: 3,
  },
  {
    createDept: '2000000134006',
    createTime: '2023-10-10 20:48:15',
    updateTime: '2023-10-10 20:48:15',
    status: 1,
    isDeleted: 0,
    id: '1711725329225207809',
    tenantId: '200000',
    name: '高板岩二站变压器',
    stationId: '901901000019',
    deptId: 2000000134006,
    isHikvideo: 1,
    type: '3',
    videoType: '1',
    liveSourceAddress: 'http://172.30.100.204:8950/openUrl/IIElx6M/live.flv',
    pointCode: 'cfe552b771b24a75aae6b02e46a40e60',
    videoHost: '172.30.100.204:443',
    appKey: '22969597',
    appSecret: 'MjEVUaU2a7K2aG85sEPU',
    sort: 4,
  },
  {
    createDept: '2000000134006',
    createTime: '2023-10-10 20:48:47',
    updateTime: '2023-10-10 20:48:47',
    status: 1,
    isDeleted: 0,
    id: '1711725461798768641',
    tenantId: '200000',
    name: '高板岩二站左前1号',
    stationId: '901901000019',
    deptId: 2000000134006,
    isHikvideo: 1,
    type: '3',
    videoType: '1',
    liveSourceAddress: 'http://172.30.100.204:8950/openUrl/IIXVR5e/live.flv',
    pointCode: 'd1d6d0c2dfba45cc82c93d5925aa6172',
    videoHost: '172.30.100.204:443',
    appKey: '22969597',
    appSecret: 'MjEVUaU2a7K2aG85sEPU',
    sort: 5,
  },
  {
    createDept: '2000000134006',
    createTime: '2023-10-10 20:49:15',
    updateTime: '2023-10-10 20:49:15',
    status: 1,
    isDeleted: 0,
    id: '1711725577691582466',
    tenantId: '200000',
    name: '高板岩二站左前2号',
    stationId: '901901000019',
    deptId: 2000000134006,
    isHikvideo: 1,
    type: '3',
    videoType: '1',
    liveSourceAddress: 'http://172.30.100.204:8950/openUrl/IJhwb3G/live.flv',
    pointCode: '0627d14697cc476f8f1a1a550245104c',
    videoHost: '172.30.100.204:443',
    appKey: '22969597',
    appSecret: 'MjEVUaU2a7K2aG85sEPU',
    sort: 6,
  },
  {
    createDept: '2000000134006',
    createTime: '2023-10-10 20:49:50',
    updateTime: '2023-10-10 20:49:50',
    status: 1,
    isDeleted: 0,
    id: '1711725723716276225',
    tenantId: '200000',
    name: '高板岩二站后墙1号',
    stationId: '901901000019',
    deptId: 2000000134006,
    isHikvideo: 1,
    type: '3',
    videoType: '1',
    liveSourceAddress: 'http://172.30.100.204:8950/openUrl/IJAxiM0/live.flv',
    pointCode: '969462513f4b460eac6b7984b6ca9675',
    videoHost: '172.30.100.204:443',
    appKey: '22969597',
    appSecret: 'MjEVUaU2a7K2aG85sEPU',
    sort: 7,
  },
  {
    createDept: '2000000134006',
    createTime: '2023-10-10 20:51:25',
    updateTime: '2023-10-10 20:51:25',
    status: 1,
    isDeleted: 0,
    id: '1711726125643845634',
    tenantId: '200000',
    name: '高板岩二站河道',
    stationId: '901901000019',
    deptId: 2000000134006,
    isHikvideo: 1,
    type: '3',
    videoType: '1',
    liveSourceAddress: 'http://172.30.100.204:8950/openUrl/IJXOpri/live.flv',
    pointCode: '1fd5cf76a06a44c0a3737d24a3317e3f',
    videoHost: '172.30.100.204:443',
    appKey: '22969597',
    appSecret: 'MjEVUaU2a7K2aG85sEPU',
    sort: 8,
  },
  {
    createDept: '2000000134006',
    createTime: '2023-10-10 20:52:08',
    updateTime: '2023-10-10 20:52:08',
    status: 1,
    isDeleted: 0,
    id: '1711726304224727042',
    tenantId: '200000',
    name: '高板岩二站左侧球机',
    stationId: '901901000019',
    deptId: 2000000134006,
    isHikvideo: 1,
    type: '3',
    videoType: '1',
    liveSourceAddress: 'http://172.30.100.204:8950/openUrl/IKhoJpK/live.flv',
    pointCode: 'ac0757237c4547f7a18fa02fe9546844',
    videoHost: '172.30.100.204:443',
    appKey: '22969597',
    appSecret: 'MjEVUaU2a7K2aG85sEPU',
    sort: 9,
  },
  {
    createDept: '2000000134006',
    createTime: '2023-10-10 20:52:40',
    updateTime: '2023-10-10 20:52:40',
    status: 1,
    isDeleted: 0,
    id: '1711726438408900610',
    tenantId: '200000',
    name: '高板岩二站后墙2号',
    stationId: '901901000019',
    deptId: 2000000134006,
    isHikvideo: 1,
    type: '3',
    videoType: '1',
    liveSourceAddress: 'http://172.30.100.204:8950/openUrl/IKAHsg8/live.flv',
    pointCode: '0e623ca7dd744422afb8306f0342d49a',
    videoHost: '172.30.100.204:443',
    appKey: '22969597',
    appSecret: 'MjEVUaU2a7K2aG85sEPU',
    sort: 10,
  },
];

// 任务统计数据
export const getTaskCount = {
  status: 0,
  code: 200,
  success: true,
  data: {
    count: 30,
    finish: 2,
    unfinished: 28,
  },
  msg: '操作成功',
};

// 任务列表数据
export const getTaskList = {
  status: 0,
  code: 200,
  success: true,
  data: [
    {
      createDept: null,
      createTime: null,
      updateTime: null,
      status: 1,
      isDeleted: null,
      id: null,
      tenantId: null,
      planId: null,
      type: null,
      planName: '机器人巡检计划',
      batchNumber: '20231102104251',
      planStartTime: null,
      planEndTime: null,
      startTime: '2023-11-02 10:42:51',
      endTime: null,
      keepOnRecord: null,
      cycle: null,
      method: null,
      userName: null,
      userId: null,
      userPhone: null,
      point: ['1', '2', '3'],
      autoVideo: null,
      planType: null,
      startRemindFlag: null,
      endRemindFlag: null,
      startRemindTime: null,
      endRemindTime: null,
      taskContent: null,
      dutyId: null,
      messageTemplateId: null,
      pushStatus: null,
      canCancel: false,
      robot: null,
    },
  ],
  msg: '操作成功',
};

// 机器人巡检任务列表
export const robotCheckList = {
  status: 0,
  code: 200,
  success: true,
  data: [
    {
      taskId: '1721780686672687105',
      objId: '1715543639578382337',
      objName: '机器人巡检_高板岩二站_综合设备屏',
      status: 0,
      duplicateRecord: '1',
      order: 1,
      dangers: [],
      projects: [
        {
          projectId: '1715280897093144577',
          projectName: '高板岩二站_综合设备屏_指示灯',
          status: 0,
          contents: [
            {
              contentId: '1715280897118310402',
              name: '高板岩二站_综合设备屏_合闸指示灯',
              description:
                '机器人巡检内容_高板岩二站_综合设备屏_合闸指示灯_灯亮表示10kV线路断路器合闸',
              available: '1',
              checkType: '5',
              recordType: '2',
              currentStatus: null,
              currentValue: null,
              fileUrl: null,
              clockId: null,
              cameraId: null,
              checkTypeSon: '1-13',
              cameraAddr: '0,0',
              otherParam: '',
              checkVal: null,
              dictType: '',
              realData: null,
              gatherTime: null,
              attrSignage: null,
              attrName: null,
              emCode: '',
            },
            {
              contentId: '1715547654882070530',
              name: '高板岩二站_综合设备屏_分闸指示灯',
              description: '机器人巡检_高板岩二站_综合设备屏_分闸指示灯_灯亮表示10kV线路断路器合闸',
              available: '1',
              checkType: '5',
              recordType: '2',
              currentStatus: null,
              currentValue: null,
              fileUrl: null,
              clockId: null,
              cameraId: null,
              checkTypeSon: '1-13',
              cameraAddr: '0,1',
              otherParam: '',
              checkVal: null,
              dictType: '',
              realData: null,
              gatherTime: null,
              attrSignage: null,
              attrName: null,
              emCode: '',
            },
            {
              contentId: '1715632698728386561',
              name: '高板岩二站_综合设备屏_旋转开关',
              description: '机器人巡检内容_高板岩二站_综合设备屏_旋转开关_检测标准',
              available: '1',
              checkType: '5',
              recordType: '2',
              currentStatus: null,
              currentValue: null,
              fileUrl: null,
              clockId: null,
              cameraId: null,
              checkTypeSon: '0',
              cameraAddr: '',
              otherParam: '',
              checkVal: null,
              dictType: '',
              realData: null,
              gatherTime: null,
              attrSignage: null,
              attrName: null,
              emCode: '',
            },
          ],
        },
        {
          projectId: '1715548207951384577',
          projectName: '高板岩二站_综合设备屏_硬压板',
          status: 0,
          contents: [
            {
              contentId: '1715548207968161793',
              name: '高板岩二站_综合设备屏_硬压板',
              description: '机器人巡检内容_高板岩二站_综合设备屏_硬压板_检测标准',
              available: '1',
              checkType: '5',
              recordType: '2',
              currentStatus: null,
              currentValue: null,
              fileUrl: null,
              clockId: null,
              cameraId: null,
              checkTypeSon: '0',
              cameraAddr: '',
              otherParam: '',
              checkVal: null,
              dictType: '',
              realData: null,
              gatherTime: null,
              attrSignage: null,
              attrName: null,
              emCode: '',
            },
          ],
        },
      ],
    },
    {
      taskId: '1721780686672687105',
      objId: '1715543400314310658',
      objName: '机器人巡检_高板岩二站_UPS柜',
      status: 0,
      duplicateRecord: '1',
      order: 2,
      dangers: [],
      projects: [
        {
          projectId: '1715279877361373185',
          projectName: '高板岩二站_UPS_仪表区&amp;指示灯',
          status: 0,
          contents: [
            {
              contentId: '1715552635211223042',
              name: '高板岩二站_UPS柜_交流电压指示灯',
              description: '机器人巡检内容_高板岩二站_UPS柜_交流电源指示灯_灯亮表示交流电输入',
              available: '1',
              checkType: '5',
              recordType: '2',
              currentStatus: null,
              currentValue: null,
              fileUrl: null,
              clockId: null,
              cameraId: null,
              checkTypeSon: '1-13',
              cameraAddr: '0,0',
              otherParam: '',
              checkVal: null,
              dictType: '',
              realData: null,
              gatherTime: null,
              attrSignage: null,
              attrName: null,
              emCode: '',
            },
            {
              contentId: '1715552635358023682',
              name: '高板岩二站_UPS柜_直流电源指示灯',
              description: '机器人巡检内容_高板岩二站_UPS柜_直流电源指示灯_灯亮表示UPS直流输入',
              available: '1',
              checkType: '5',
              recordType: '2',
              currentStatus: null,
              currentValue: null,
              fileUrl: null,
              clockId: null,
              cameraId: null,
              checkTypeSon: '1-13',
              cameraAddr: '0,1',
              otherParam: '',
              checkVal: null,
              dictType: '',
              realData: null,
              gatherTime: null,
              attrSignage: null,
              attrName: null,
              emCode: '',
            },
            {
              contentId: '1715552635412549634',
              name: '高板岩二站_UPS柜_旁路电源指示灯',
              description: '机器人巡检内容_高板岩二站_UPS柜_旁路电源指示灯_灯亮表示旁路电源输入',
              available: '1',
              checkType: '5',
              recordType: '2',
              currentStatus: null,
              currentValue: null,
              fileUrl: null,
              clockId: null,
              cameraId: null,
              checkTypeSon: '1-13',
              cameraAddr: '0,2',
              otherParam: '',
              checkVal: null,
              dictType: '',
              realData: null,
              gatherTime: null,
              attrSignage: null,
              attrName: null,
              emCode: '',
            },
            {
              contentId: '1715552635420938241',
              name: '高板岩二站_UPS柜_输出电源指示灯',
              description: '机器人巡检内容_高板岩二站_UPS柜_输出电源指示灯_灯亮表示UPS输出',
              available: '1',
              checkType: '5',
              recordType: '2',
              currentStatus: null,
              currentValue: null,
              fileUrl: null,
              clockId: null,
              cameraId: null,
              checkTypeSon: '1-13',
              cameraAddr: '0,3',
              otherParam: '',
              checkVal: null,
              dictType: '',
              realData: null,
              gatherTime: null,
              attrSignage: null,
              attrName: null,
              emCode: '',
            },
            {
              contentId: '1715552635425132546',
              name: '高板岩二站_UPS柜_维修开关指示灯',
              description: '机器人巡检内容_高板岩二站_UPS柜_维修开关指示灯_灯亮表示UPS处于维修状态',
              available: '1',
              checkType: '5',
              recordType: '2',
              currentStatus: null,
              currentValue: null,
              fileUrl: null,
              clockId: null,
              cameraId: null,
              checkTypeSon: '1-13',
              cameraAddr: '0,4',
              otherParam: '',
              checkVal: null,
              dictType: '',
              realData: null,
              gatherTime: null,
              attrSignage: null,
              attrName: null,
              emCode: '',
            },
            {
              contentId: '1720256131974070274',
              name: 'UPS柜_仪表识别',
              description: 'UPS柜交流电输入电源',
              available: '1',
              checkType: '5',
              recordType: '2',
              currentStatus: null,
              currentValue: null,
              fileUrl: null,
              clockId: null,
              cameraId: null,
              checkTypeSon: '1-21',
              cameraAddr: '0,0',
              otherParam: '',
              checkVal: null,
              dictType: '',
              realData: null,
              gatherTime: null,
              attrSignage: null,
              attrName: null,
              emCode: '',
            },
            {
              contentId: '1720256479870615553',
              name: 'UPS柜_直流输入电源表',
              description: 'UPS柜直流输入电压',
              available: '1',
              checkType: '5',
              recordType: '2',
              currentStatus: null,
              currentValue: null,
              fileUrl: null,
              clockId: null,
              cameraId: null,
              checkTypeSon: '1-21',
              cameraAddr: '0,1',
              otherParam: '',
              checkVal: null,
              dictType: '',
              realData: null,
              gatherTime: null,
              attrSignage: null,
              attrName: null,
              emCode: '',
            },
            {
              contentId: '1720257729764818945',
              name: 'UPS柜_交流输出电压表',
              description: 'UPS交流输出电压',
              available: '1',
              checkType: '5',
              recordType: '2',
              currentStatus: null,
              currentValue: null,
              fileUrl: null,
              clockId: null,
              cameraId: null,
              checkTypeSon: '1-21',
              cameraAddr: '0,2',
              otherParam: '',
              checkVal: null,
              dictType: '',
              realData: null,
              gatherTime: null,
              attrSignage: null,
              attrName: null,
              emCode: '',
            },
            {
              contentId: '1720258766915534849',
              name: 'UPS柜_交流输出电流',
              description: 'UPS柜交流输出电流',
              available: '1',
              checkType: '5',
              recordType: '2',
              currentStatus: null,
              currentValue: null,
              fileUrl: null,
              clockId: null,
              cameraId: null,
              checkTypeSon: '1-21',
              cameraAddr: '0,3',
              otherParam: '',
              checkVal: null,
              dictType: '',
              realData: null,
              gatherTime: null,
              attrSignage: null,
              attrName: null,
              emCode: '',
            },
          ],
        },
      ],
    },
    {
      taskId: '1721780686672687105',
      objId: '1714829455886729217',
      objName: '机器人巡检对象_高板岩二站_机组控制屏',
      status: 0,
      duplicateRecord: '1',
      order: 3,
      dangers: [],
      projects: [
        {
          projectId: '1715561952220024833',
          projectName: '高板岩二站_机组智控屏_断路器',
          status: 0,
          contents: [
            {
              contentId: '1715561952266162178',
              name: '高板岩二站_机组智控屏_断路器',
              description: '机器人巡检内容_高板岩二站_机组智控屏_断路器_检测标准',
              available: '1',
              checkType: '5',
              recordType: '2',
              currentStatus: null,
              currentValue: null,
              fileUrl: null,
              clockId: null,
              cameraId: null,
              checkTypeSon: '0',
              cameraAddr: '',
              otherParam: '',
              checkVal: null,
              dictType: '',
              realData: null,
              gatherTime: null,
              attrSignage: null,
              attrName: null,
              emCode: '',
            },
          ],
        },
        {
          projectId: '1715561545578057729',
          projectName: '高板岩二站_机组智控屏_旋钮区',
          status: 0,
          contents: [
            {
              contentId: '1715561545594834946',
              name: '高板岩二站_机组智控屏_旋钮开关',
              description: '机器人巡检内容_高板岩二站_机组智控屏_旋钮开关',
              available: '1',
              checkType: '5',
              recordType: '2',
              currentStatus: null,
              currentValue: null,
              fileUrl: null,
              clockId: null,
              cameraId: null,
              checkTypeSon: '0',
              cameraAddr: '',
              otherParam: '',
              checkVal: null,
              dictType: '',
              realData: null,
              gatherTime: null,
              attrSignage: null,
              attrName: null,
              emCode: '',
            },
          ],
        },
        {
          projectId: '1714828408350916609',
          projectName: '高板岩二站_机组控制屏_仪表区',
          status: 0,
          contents: [
            {
              contentId: '1715561035756212225',
              name: '高板岩二站_机组智控屏_断路器工作位置指示灯',
              description:
                '机器人巡检内容_高板岩二站_机组智控屏_断路器工作位置指示灯_灯亮表示断路器处于工作位置',
              available: '1',
              checkType: '5',
              recordType: '2',
              currentStatus: null,
              currentValue: null,
              fileUrl: null,
              clockId: null,
              cameraId: null,
              checkTypeSon: '1-13',
              cameraAddr: '0,3',
              otherParam: '',
              checkVal: null,
              dictType: '',
              realData: null,
              gatherTime: null,
              attrSignage: null,
              attrName: null,
              emCode: '',
            },
            {
              contentId: '1715561035747823617',
              name: '高板岩二站_机组智控屏_断路器储能指示灯',
              description:
                '机器人巡检内容_高板岩二站_机组智控屏_断路器储能指示灯_灯亮表示断路器已储能',
              available: '1',
              checkType: '5',
              recordType: '2',
              currentStatus: null,
              currentValue: null,
              fileUrl: null,
              clockId: null,
              cameraId: null,
              checkTypeSon: '1-13',
              cameraAddr: '0,2',
              otherParam: '',
              checkVal: null,
              dictType: '',
              realData: null,
              gatherTime: null,
              attrSignage: null,
              attrName: null,
              emCode: '',
            },
            {
              contentId: '1715561035739435010',
              name: '高板岩二站_机组智控屏_断路器合闸指示灯',
              description: '机器人巡检内容_高板岩二站_机组智控屏_合闸指示灯_灯亮表示合闸',
              available: '1',
              checkType: '5',
              recordType: '2',
              currentStatus: null,
              currentValue: null,
              fileUrl: null,
              clockId: null,
              cameraId: null,
              checkTypeSon: '1-13',
              cameraAddr: '0,1',
              otherParam: '',
              checkVal: null,
              dictType: '',
              realData: null,
              gatherTime: null,
              attrSignage: null,
              attrName: null,
              emCode: '',
            },
            {
              contentId: '1715561035726852098',
              name: '高板岩二站_机组控制屏_断路器分闸指示灯',
              description:
                '机器人巡检内容_高板岩二站_机组智控屏_断路器分闸指示灯_灯亮表示断路器分闸',
              available: '1',
              checkType: '5',
              recordType: '2',
              currentStatus: null,
              currentValue: null,
              fileUrl: null,
              clockId: null,
              cameraId: null,
              checkTypeSon: '1-13',
              cameraAddr: '0,0',
              otherParam: '',
              checkVal: null,
              dictType: '',
              realData: null,
              gatherTime: null,
              attrSignage: null,
              attrName: null,
              emCode: '',
            },
            {
              contentId: '1715561035714269185',
              name: '高板岩二站_机组智控屏_仪表区',
              description: '高板岩二站_机组智控屏_仪表',
              available: '1',
              checkType: '5',
              recordType: '2',
              currentStatus: null,
              currentValue: null,
              fileUrl: null,
              clockId: null,
              cameraId: null,
              checkTypeSon: '0',
              cameraAddr: '',
              otherParam: '',
              checkVal: null,
              dictType: '',
              realData: null,
              gatherTime: null,
              attrSignage: null,
              attrName: null,
              emCode: '',
            },
            {
              contentId: '1720272170585718786',
              name: '高板岩二站_机组智控屏_励磁电流表',
              description: '机组智控屏励磁电流表',
              available: '1',
              checkType: '5',
              recordType: '2',
              currentStatus: null,
              currentValue: null,
              fileUrl: null,
              clockId: '1720271550298488834',
              cameraId: null,
              checkTypeSon: '1-11',
              cameraAddr: '0,3',
              otherParam: '',
              checkVal: null,
              dictType: '',
              realData: null,
              gatherTime: null,
              attrSignage: null,
              attrName: null,
              emCode: '',
            },
          ],
        },
      ],
    },
    {
      taskId: '1721780686672687105',
      objId: '1715543180264345601',
      objName: '机器人巡检_高板岩二站_厂用配电屏',
      status: 0,
      duplicateRecord: '1',
      order: 4,
      dangers: [],
      projects: [
        {
          projectId: '1715277496779280386',
          projectName: '高板岩二站_厂用配电柜_仪表',
          status: 0,
          contents: [
            {
              contentId: '1715277496808640514',
              name: '高板岩二站_厂用配电屏_交流电源指示灯',
              description: '机器人巡检内容_高板岩二站_厂用配电屏_交流电源指示灯_灯亮表示有交流电源',
              available: '1',
              checkType: '5',
              recordType: '2',
              currentStatus: null,
              currentValue: null,
              fileUrl: null,
              clockId: null,
              cameraId: null,
              checkTypeSon: '1-13',
              cameraAddr: '0,0',
              otherParam: '',
              checkVal: null,
              dictType: '',
              realData: null,
              gatherTime: null,
              attrSignage: null,
              attrName: null,
              emCode: '',
            },
            {
              contentId: '1715557949025292290',
              name: '高板岩二站_厂用配电屏_仪表区',
              description: '厂用配电屏_仪表区',
              available: '1',
              checkType: '5',
              recordType: '2',
              currentStatus: null,
              currentValue: null,
              fileUrl: null,
              clockId: null,
              cameraId: null,
              checkTypeSon: '0',
              cameraAddr: '',
              otherParam: '',
              checkVal: null,
              dictType: '',
              realData: null,
              gatherTime: null,
              attrSignage: null,
              attrName: null,
              emCode: '',
            },
          ],
        },
        {
          projectId: '1715558315343220737',
          projectName: '高板岩二站_厂用配电屏_指示灯',
          status: 0,
          contents: [
            {
              contentId: '1715558315359997954',
              name: '高板岩二站_厂用配电屏_指示灯区',
              description: '机器人检测内容_高板岩二站_厂用配电屏_指示灯',
              available: '1',
              checkType: '5',
              recordType: '2',
              currentStatus: null,
              currentValue: null,
              fileUrl: null,
              clockId: null,
              cameraId: null,
              checkTypeSon: '0',
              cameraAddr: '',
              otherParam: '',
              checkVal: null,
              dictType: '',
              realData: null,
              gatherTime: null,
              attrSignage: null,
              attrName: null,
              emCode: '',
            },
            {
              contentId: '1719616801278631938',
              name: '高板岩二站_厂用配电屏_1#调速器',
              description: '高板岩二站_厂用配电屏_1#调速器_灯亮调速器有电源',
              available: '1',
              checkType: '5',
              recordType: '2',
              currentStatus: null,
              currentValue: null,
              fileUrl: null,
              clockId: null,
              cameraId: null,
              checkTypeSon: '1-13',
              cameraAddr: '2,1',
              otherParam: '',
              checkVal: null,
              dictType: '',
              realData: null,
              gatherTime: null,
              attrSignage: null,
              attrName: null,
              emCode: '',
            },
            {
              contentId: '1719616382200553473',
              name: '高板岩二站_厂用配电屏_EPS电源',
              description: '高板岩二站_厂用配电屏_EPS电源_灯亮表示市电电源',
              available: '1',
              checkType: '5',
              recordType: '2',
              currentStatus: null,
              currentValue: null,
              fileUrl: null,
              clockId: null,
              cameraId: null,
              checkTypeSon: '1-13',
              cameraAddr: '1,1',
              otherParam: '',
              checkVal: null,
              dictType: '',
              realData: null,
              gatherTime: null,
              attrSignage: null,
              attrName: null,
              emCode: '',
            },
            {
              contentId: '1719615858847883266',
              name: '高板岩二站_厂用配电屏_1#进水阀',
              description: '高板岩二站_厂用配电屏_1#进水阀_灯亮表示进水阀门有电',
              available: '1',
              checkType: '5',
              recordType: '2',
              currentStatus: null,
              currentValue: null,
              fileUrl: null,
              clockId: null,
              cameraId: null,
              checkTypeSon: '1-13',
              cameraAddr: '0,2',
              otherParam: '',
              checkVal: null,
              dictType: '',
              realData: null,
              gatherTime: null,
              attrSignage: null,
              attrName: null,
              emCode: '',
            },
            {
              contentId: '1719585385614516225',
              name: '高板岩二站_厂用配电屏_1#机组调速器油泵',
              description: '高板岩二站_厂用配电屏_1#机组调速器油泵_灯亮表示调速器有电',
              available: '1',
              checkType: '5',
              recordType: '2',
              currentStatus: null,
              currentValue: null,
              fileUrl: null,
              clockId: null,
              cameraId: null,
              checkTypeSon: '1-13',
              cameraAddr: '0,0',
              otherParam: '',
              checkVal: null,
              dictType: '',
              realData: null,
              gatherTime: null,
              attrSignage: null,
              attrName: null,
              emCode: '',
            },
          ],
        },
      ],
    },
    {
      taskId: '1721780686672687105',
      objId: '1715947423529963522',
      objName: '高板岩二站_发电机组_蜗壳压力表',
      status: 0,
      duplicateRecord: '1',
      order: 5,
      dangers: [],
      projects: [
        {
          projectId: '1715597277503950850',
          projectName: '高板岩二站_发电机组_蜗壳压力表',
          status: 0,
          contents: [
            {
              contentId: '1720273627003256834',
              name: '高板岩二站_发电机组_蜗壳压力表',
              description: '发电机组蜗壳压力',
              available: '1',
              checkType: '5',
              recordType: '2',
              currentStatus: null,
              currentValue: null,
              fileUrl: null,
              clockId: null,
              cameraId: null,
              checkTypeSon: '1-21',
              cameraAddr: '0,0',
              otherParam: '',
              checkVal: null,
              dictType: '',
              realData: null,
              gatherTime: null,
              attrSignage: null,
              attrName: null,
              emCode: '',
            },
          ],
        },
      ],
    },
    {
      taskId: '1721780686672687105',
      objId: '1715946631691505666',
      objName: '高板岩二站_发电机组_尾水真空压力表',
      status: 0,
      duplicateRecord: '1',
      order: 6,
      dangers: [],
      projects: [
        {
          projectId: '1715596266529886210',
          projectName: '高板岩二站_发电机组_尾水真空压力表',
          status: 0,
          contents: [
            {
              contentId: '1720274763827412994',
              name: '高板岩二站_发电机组_尾水真空压力表',
              description: '发电机组尾水真空压力',
              available: '1',
              checkType: '5',
              recordType: '2',
              currentStatus: null,
              currentValue: null,
              fileUrl: null,
              clockId: '1720271550298488834',
              cameraId: null,
              checkTypeSon: '1-11',
              cameraAddr: '0,3',
              otherParam: '',
              checkVal: null,
              dictType: '',
              realData: null,
              gatherTime: null,
              attrSignage: null,
              attrName: null,
              emCode: '',
            },
          ],
        },
      ],
    },
    {
      taskId: '1721780686672687105',
      objId: '1715949573135929346',
      objName: '高板岩二站_进水阀控制箱',
      status: 0,
      duplicateRecord: '1',
      order: 7,
      dangers: [],
      projects: [
        {
          projectId: '1715275196996259842',
          projectName: '高板岩二站_进水阀控制箱',
          status: 0,
          contents: [
            {
              contentId: '1715275197130477570',
              name: '高板岩二站_进水阀控制箱',
              description: '机器人巡检内容_高板岩二站_进水阀控制箱_检测标准',
              available: '1',
              checkType: '5',
              recordType: '2',
              currentStatus: null,
              currentValue: null,
              fileUrl: null,
              clockId: null,
              cameraId: null,
              checkTypeSon: '0',
              cameraAddr: '',
              otherParam: '',
              checkVal: null,
              dictType: '',
              realData: null,
              gatherTime: null,
              attrSignage: null,
              attrName: null,
              emCode: '',
            },
            {
              contentId: '1719619674121019394',
              name: '高板岩二站_阀门控制箱_导叶全关',
              description: '灯亮表示导叶全关',
              available: '1',
              checkType: '5',
              recordType: '2',
              currentStatus: null,
              currentValue: null,
              fileUrl: null,
              clockId: null,
              cameraId: null,
              checkTypeSon: '1-13',
              cameraAddr: '2,3',
              otherParam: '',
              checkVal: null,
              dictType: '',
              realData: null,
              gatherTime: null,
              attrSignage: null,
              attrName: null,
              emCode: '',
            },
            {
              contentId: '1719619509494587394',
              name: '高板岩二站_阀门控制箱_PLC工作',
              description: '灯亮表示PLC处于工作状态',
              available: '1',
              checkType: '5',
              recordType: '2',
              currentStatus: null,
              currentValue: null,
              fileUrl: null,
              clockId: null,
              cameraId: null,
              checkTypeSon: '1-13',
              cameraAddr: '2,1',
              otherParam: '',
              checkVal: null,
              dictType: '',
              realData: null,
              gatherTime: null,
              attrSignage: null,
              attrName: null,
              emCode: '',
            },
            {
              contentId: '1719619280133267458',
              name: '高板岩二站_阀门控制箱_旁通全关',
              description: '灯亮表示旁通全关',
              available: '1',
              checkType: '5',
              recordType: '2',
              currentStatus: null,
              currentValue: null,
              fileUrl: null,
              clockId: null,
              cameraId: null,
              checkTypeSon: '1-13',
              cameraAddr: '1,3',
              otherParam: '',
              checkVal: null,
              dictType: '',
              realData: null,
              gatherTime: null,
              attrSignage: null,
              attrName: null,
              emCode: '',
            },
            {
              contentId: '1719619126961479682',
              name: '高板岩二站_阀门控制箱_旁通全开',
              description: '灯亮表示旁通全开',
              available: '1',
              checkType: '5',
              recordType: '2',
              currentStatus: null,
              currentValue: null,
              fileUrl: null,
              clockId: null,
              cameraId: null,
              checkTypeSon: '1-13',
              cameraAddr: '1,2',
              otherParam: '',
              checkVal: null,
              dictType: '',
              realData: null,
              gatherTime: null,
              attrSignage: null,
              attrName: null,
              emCode: '',
            },
            {
              contentId: '1719618878855815169',
              name: '高板岩二站_阀门控制箱_主阀全关',
              description: '灯亮表示主阀全关',
              available: '1',
              checkType: '5',
              recordType: '2',
              currentStatus: null,
              currentValue: null,
              fileUrl: null,
              clockId: null,
              cameraId: null,
              checkTypeSon: '1-13',
              cameraAddr: '1,1',
              otherParam: '',
              checkVal: null,
              dictType: '',
              realData: null,
              gatherTime: null,
              attrSignage: null,
              attrName: null,
              emCode: '',
            },
            {
              contentId: '1719618705916272641',
              name: '高板岩二站_阀门控制箱_主阀全开',
              description: '灯亮表示主阀全开',
              available: '1',
              checkType: '5',
              recordType: '2',
              currentStatus: null,
              currentValue: null,
              fileUrl: null,
              clockId: null,
              cameraId: null,
              checkTypeSon: '1-13',
              cameraAddr: '1,0',
              otherParam: '',
              checkVal: null,
              dictType: '',
              realData: null,
              gatherTime: null,
              attrSignage: null,
              attrName: null,
              emCode: '',
            },
            {
              contentId: '1719618054842851330',
              name: '高板岩二站_阀门控制箱_电源指示',
              description: '灯亮表示设备市电',
              available: '1',
              checkType: '5',
              recordType: '2',
              currentStatus: null,
              currentValue: null,
              fileUrl: null,
              clockId: null,
              cameraId: null,
              checkTypeSon: '1-13',
              cameraAddr: '0,0',
              otherParam: '',
              checkVal: null,
              dictType: '',
              realData: null,
              gatherTime: null,
              attrSignage: null,
              attrName: null,
              emCode: '',
            },
            {
              contentId: '1719618217229524994',
              name: '高板岩二站_阀门控制箱_UPS电源',
              description: '灯亮表示设备使用UPS电源',
              available: '1',
              checkType: '5',
              recordType: '2',
              currentStatus: null,
              currentValue: null,
              fileUrl: null,
              clockId: null,
              cameraId: null,
              checkTypeSon: '1-13',
              cameraAddr: '0,1',
              otherParam: '',
              checkVal: null,
              dictType: '',
              realData: null,
              gatherTime: null,
              attrSignage: null,
              attrName: null,
              emCode: '',
            },
          ],
        },
      ],
    },
    {
      taskId: '1721780686672687105',
      objId: '1715542973388689409',
      objName: '机器人巡检_高板岩二站_进水阀',
      status: 0,
      duplicateRecord: '1',
      order: 8,
      dangers: [],
      projects: [
        {
          projectId: '1715555666011099138',
          projectName: '高板岩二站_进水阀门',
          status: 0,
          contents: [
            {
              contentId: '1715555666027876353',
              name: '高板岩二站_进水阀门',
              description: '机器人巡检内容_高板岩二站_进水阀门_检测标准',
              available: '1',
              checkType: '5',
              recordType: '2',
              currentStatus: null,
              currentValue: null,
              fileUrl: null,
              clockId: null,
              cameraId: null,
              checkTypeSon: '0',
              cameraAddr: '',
              otherParam: '',
              checkVal: null,
              dictType: '',
              realData: null,
              gatherTime: null,
              attrSignage: null,
              attrName: null,
              emCode: '',
            },
          ],
        },
      ],
    },
    {
      taskId: '1721780686672687105',
      objId: '1715946559163600898',
      objName: '巡检对象_高板岩二站_发电机组_导水机构',
      status: 0,
      duplicateRecord: '1',
      order: 9,
      dangers: [],
      projects: [
        {
          projectId: '1715596931952021506',
          projectName: '高板岩二站_发电机组_导水机构',
          status: 0,
          contents: [
            {
              contentId: '1715596932174319617',
              name: '高板岩二站_发电机组_导水机构',
              description: '机器人巡检内容_高板岩二站_发电机组_导水机构',
              available: '1',
              checkType: '5',
              recordType: '2',
              currentStatus: null,
              currentValue: null,
              fileUrl: null,
              clockId: null,
              cameraId: null,
              checkTypeSon: '0',
              cameraAddr: '',
              otherParam: '',
              checkVal: null,
              dictType: '',
              realData: null,
              gatherTime: null,
              attrSignage: null,
              attrName: null,
              emCode: '',
            },
          ],
        },
      ],
    },
    {
      taskId: '1721780686672687105',
      objId: '1715542060871716866',
      objName: '机器人巡检对象_高板岩二站_调速器',
      status: 0,
      duplicateRecord: '1',
      order: 10,
      dangers: [],
      projects: [
        {
          projectId: '1715271796556566529',
          projectName: '高板岩二站_调速器控制箱',
          status: 0,
          contents: [
            {
              contentId: '1715271796669812737',
              name: '高板岩二站_调速器控制箱',
              description: '面板和油压表',
              available: '1',
              checkType: '5',
              recordType: '2',
              currentStatus: null,
              currentValue: null,
              fileUrl: null,
              clockId: null,
              cameraId: null,
              checkTypeSon: '0',
              cameraAddr: '',
              otherParam: '',
              checkVal: null,
              dictType: '',
              realData: null,
              gatherTime: null,
              attrSignage: null,
              attrName: null,
              emCode: '',
            },
            {
              contentId: '1719617171178496001',
              name: '高板岩二站_调速器_自动运行',
              description: '灯亮表示自动运行',
              available: '1',
              checkType: '5',
              recordType: '2',
              currentStatus: null,
              currentValue: null,
              fileUrl: null,
              clockId: null,
              cameraId: null,
              checkTypeSon: '1-13',
              cameraAddr: '0,1',
              otherParam: '',
              checkVal: null,
              dictType: '',
              realData: null,
              gatherTime: null,
              attrSignage: null,
              attrName: null,
              emCode: '',
            },
            {
              contentId: '1719617502260076546',
              name: '高板岩二站_调速器_故障',
              description: '灯亮表示调速器故障报警',
              available: '1',
              checkType: '5',
              recordType: '2',
              currentStatus: null,
              currentValue: null,
              fileUrl: null,
              clockId: null,
              cameraId: null,
              checkTypeSon: '1-13',
              cameraAddr: '0,2',
              otherParam: '',
              checkVal: null,
              dictType: '',
              realData: null,
              gatherTime: null,
              attrSignage: null,
              attrName: null,
              emCode: '',
            },
          ],
        },
      ],
    },
    {
      taskId: '1721780686672687105',
      objId: '1715542579577098242',
      objName: '巡检对象_高板岩二站_发电机组_制动器',
      status: 0,
      duplicateRecord: '1',
      order: 11,
      dangers: [],
      projects: [
        {
          projectId: '1715273841283960834',
          projectName: '高板岩二站_发电机组_制动器',
          status: 0,
          contents: [
            {
              contentId: '1715298033471590401',
              name: '高板岩二站_发电机组_制动器',
              description: '机器人巡检内容_高板岩二站_发电机组_制动器_检测标准',
              available: '1',
              checkType: '5',
              recordType: '2',
              currentStatus: null,
              currentValue: null,
              fileUrl: null,
              clockId: null,
              cameraId: null,
              checkTypeSon: '0',
              cameraAddr: '',
              otherParam: '',
              checkVal: null,
              dictType: '',
              realData: null,
              gatherTime: null,
              attrSignage: null,
              attrName: null,
              emCode: '',
            },
          ],
        },
      ],
    },
  ],
  msg: '操作成功',
};
